<template>
  <div class="itemDetail">
    <!--    <AppHead v-if="$store.getters.showDialogContainer" @menu="$ebus.$emit('goBack')"></AppHead>-->

    <div class="page noselect" style="min-height: var(--layout-height);"
         :class="{withSearchbar: $store.getters.searchIsRenderedNow && !addDirectly, noPadding: !!$store.getters.showDialogContainer}">

      <v-container class="pt-0" v-if="$store.state.showCatSlider && !addDirectly">
        <cat-slider class=""></cat-slider>
      </v-container>

      <v-container fluid>
        <v-layout>
          <v-flex xs12 md8>
            <div class="mobile">

              <div class="product-image limited d-inline-block"
                   v-if="allImages.length > 0"
                   :class="{pointer: imgSource.indexOf('placeholder') === -1, hasmoreimages: hasMoreImages}"
                   @click.passive="clickImage">
                <div class="prelative d-inline-block">
                  <!--                  <div class="stoerer abs" v-if="item.neu">NEU</div>-->
                  <!--                                            //TODO Zoom component-->
                  <!--                                            <image-zoom-->
                  <!--                                                    class="mainImage"-->
                  <!--                                                    :class="{pointer: imgSource.indexOf('placeholder') === -1}"-->
                  <!--                                                    :regular="imgSource"-->
                  <!--                                                    >-->
                  <!--                                            </image-zoom>-->
                  <img class="mainImage" :src="imgSource" alt=""
                       :class="{pointer: imgSource.indexOf('placeholder') === -1}">
                </div>
              </div>

              <!--              <div class="text-center mobileImg"-->
              <!--                   :class="{'pt-8': showAnyImage && imgSource.includes('placeholde')}"-->
              <!--              >-->
              <!--                &lt;!&ndash;                shouldContain = true&ndash;&gt;-->

              <!--                <div class="prelative" :class="{'mt-3': item.neu}">-->
              <!--                  <div class="stoerer abs" v-if="item.neu">NEU</div>-->
              <!--                  <v-img-->
              <!--                    @click.native.passive="clickMobileImage"-->
              <!--                    v-if="allImages.length > 0 && !(imgSource.includes('placeholde') && !$store.state.showPlaceholders)"-->
              <!--                    :src="imgSource"-->
              <!--                    contain-->
              <!--                    :max-height="imgSource.includes('placeholde') ? '170' : '240'"-->
              <!--                    max-width="92vw"-->
              <!--                    position="center center"></v-img>-->
              <!--                </div>-->
              <!--              </div>-->

              <!--                style="max-width: 65vw;"-->
              <!--                :style="{'max-width': (hasMoreImages === true ? '70vw' : '100%') }"-->
              <!--              <div class="moreImagesBottom" v-if="hasMoreImages">-->
              <!--                <div class="d-inline-block">-->
              <!--                  <div class="moreImage"-->
              <!--                       :style="{ 'background-image': 'url(' + item.image + ')' }"-->
              <!--                       @click.passive.stop="currentSource = item.image; showLightbox = true"-->
              <!--                  >-->
              <!--                  </div>-->
              <!--                  <div class="moreImage"-->
              <!--                       v-for="img of item.moreImages"-->
              <!--                       :style="{ 'background-image': 'url(' + img + ')' }"-->
              <!--                       @click.passive.stop="currentSource = img; showLightbox = true"-->
              <!--                  >-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--              </div>-->

              <div class="spacer-15" style="height: 40px;"
                   v-if="hasKennzeichnung && (allImages.length === 0 || (imgSource.includes('placeholde') && !$store.state.showPlaceholders))"
              ></div>

              <div v-if="hasKennzeichnung">
                <div class="badge"
                     style="position: absolute; top:85px; left: 12px;"
                >
                  <img v-for="badge in badges"
                       class="mr-2"
                       :src="badge.src">
                </div>
              </div>


              <!--            <div class="product-image" @click.passive="clickMobileImage" v-if="allImages.length > 0">-->
              <!--                <v-img-->
              <!--                        :src="imgSource"-->
              <!--                        cover-->
              <!--                        position="center center"-->
              <!--                        height="250"-->
              <!--                />-->
              <!--                &lt;!&ndash;                <div class="absBack" style="top:0">&ndash;&gt;-->
              <!--                &lt;!&ndash;                    <div>&ndash;&gt;-->
              <!--                &lt;!&ndash;                        <v-icon onclick="window.history.back()" medium dark>mdi-arrow-left</v-icon>&ndash;&gt;-->
              <!--                &lt;!&ndash;                    </div>&ndash;&gt;-->
              <!--                &lt;!&ndash;                </div>&ndash;&gt;-->
              <!--                &lt;!&ndash;                <div class="heart">&ndash;&gt;-->
              <!--                &lt;!&ndash;                    <v-btn dark icon style="width: 50px; height: 50px"&ndash;&gt;-->
              <!--                &lt;!&ndash;                           @click.native.passive.stop="switchFavorite">&ndash;&gt;-->
              <!--                &lt;!&ndash;                        <v-icon x-large color="red" v-if="isFavorite">mdi-heart</v-icon>&ndash;&gt;-->
              <!--                &lt;!&ndash;                        <v-icon x-large v-else>mdi-heart-outline</v-icon>&ndash;&gt;-->
              <!--                &lt;!&ndash;                    </v-btn>&ndash;&gt;-->
              <!--                &lt;!&ndash;                </div>&ndash;&gt;-->
              <!--                <div v-if="hasKennzeichnung" class="absKennz">-->
              <!--                    <div class="badge" v-for="badge in badges">-->
              <!--                        <img :src="badge.src">-->
              <!--                    </div>-->
              <!--                </div>-->
              <!--                <div class="moreImagesBottom" v-if="hasMoreImages">-->
              <!--                    &lt;!&ndash;                                <div class="d-flex">&ndash;&gt;-->
              <!--                    &lt;!&ndash;                    <div class="moreImage"&ndash;&gt;-->
              <!--                    &lt;!&ndash;                         :style="{ 'background-image': 'url(' + item.image + ')' }"&ndash;&gt;-->
              <!--                    &lt;!&ndash;                         @click.passive.stop="currentSource =''; showLightbox = true"&ndash;&gt;-->
              <!--                    &lt;!&ndash;                         @mouseover="currentSource =''"&ndash;&gt;-->
              <!--                    &lt;!&ndash;                    ></div>&ndash;&gt;-->
              <!--                    <div class="moreImage"-->
              <!--                         :style="{ 'background-image': 'url(' + item.image + ')' }"-->
              <!--                         @click.passive.stop="currentSource = item.image; showLightbox = true"-->
              <!--                    >-->
              <!--                    </div>-->
              <!--                    <div class="moreImage"-->
              <!--                         v-for="img of item.moreImages"-->
              <!--                         :style="{ 'background-image': 'url(' + img + ')' }"-->
              <!--                         @click.passive.stop="currentSource = img; showLightbox = true"-->
              <!--                    >-->
              <!--                    </div>-->
              <!--                    &lt;!&ndash;                                </div>&ndash;&gt;-->
              <!--                </div>-->
              <!--            </div>-->
              <!--                        <div class="spacer-15"></div>-->
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12 class="pt-5">
                    <div class="d-flex">
                      <div>
                        <span v-if="item.neu" class="stoerer mr-2 superValign">NEU</span>
                        <h2 class="itemTitle headColor d-inline hyphens" v-html="item.nameDE"></h2>
                        <span v-if="item.substances && item.substances.lAlk"><sup class="alk"
                                                                                  :class="{bgLight:bgLight}">mit Alkohol</sup></span>
                      </div>
                      <div class="heart d-inline-block mr-2" v-if="$store.state.enableFavs">
                        <v-btn class="rounded100" dark icon style="width: 35px; height: 35px"
                               @click.native.passive.stop="switchFavorite">
                          <v-icon medium color="red" v-if="isFavorite">mdi-heart</v-icon>
                          <v-icon medium color="#888888" v-else>mdi-heart-outline</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </v-flex>
                  <!--                        <v-flex xs4 class="text-right">-->
                  <!--                            &lt;!&ndash;                            style="transform: scale(0.8); transform-origin: center top;"&ndash;&gt;-->
                  <!--                            <add-to-cart-button :noblink="noblink"-->
                  <!--                                                v-if="item.sizes && item.sizes.length > 0 && total > 0"-->
                  <!--                                                @click.native.passive="addToCart"-->
                  <!--                                                :total="total"></add-to-cart-button>-->
                  <!--                        </v-flex>-->

                  <v-flex xs12 style="padding-top: 0;">
                    <div v-if="item.descriptionDE" class="pt-3 pb-3" v-html="item.descriptionDE"></div>
                    <div v-if="$store.state.enableBestand && $store.state.enableBestandanzeigeInItemList && item.bestand && item.bestand !== -1">
                      Bestand: {{item.bestand}}
                    </div>


                    <!--                            <div v-if="item.cmRatio">-->
                    <!--                                <v-icon>mdi-corn</v-icon>-->
                    <!--                                {{item.cmRatio}}-->
                    <!--                            </div>-->
                    <div v-if="item.gramm" class="d-flex align-center">
                      <v-icon class="mr-1">mdi-weight-gram</v-icon>
                      Gewicht:
                      {{ item.gramm }}g
                    </div>
                    <div class="d-flex mt-3">
                      <div class="flex-shrink-0"
                           v-if="item.sizes && item.sizes.length === 1 && item.sizes[0].vol">
                        <!--                                <v-icon>mdi-weight-gram</v-icon>-->
                        {{ item.sizes[0].vol }}<span class="headline" style="opacity: 0">1</span>
                      </div>
                      <div class="flex-shrink-0 text-no-wrap fastGrow text-left">
                        <v-layout>
                          <v-flex xs12 v-if="total">
                            <div class="biggerFont" v-if="!$store.getters.hidePrices">
                              Preis:
                              <span class="preis titleFont ml-2"
                                    :class="{oprice: item.streichPreis}">{{ total | priceTotal }}</span>
                              <span v-if="readyToAdd(item) && item.streichPreis"
                                    class="streichPreisCrossed ml-2">{{ item.streichPreis | price }}</span>
                            </div>
                            <div v-if="item.kilopreis && !$store.getters.hidePrices"><b>{{ item.kilopreis }}</b></div>
                            <div class="mb-4" v-if="!$store.getters.hidePrices">inkl. MwSt.
                              <!--                                                        zzgl.-->
                              <!--                                                        <router-link @click.native.passive="jt"-->
                              <!--                                                                     :to="{ name: 'Lieferkosten' }">-->
                              <!--                                                            Versand-->
                              <!--                                        </router-link>-->
                            </div>
                            <!--                                                    <div v-if="item.gramm || item.sizes && item.sizes.length === 1 && item.sizes[0].vol"-->
                            <!--                                                         class="d-flex align-center">-->
                            <!--                                                        <v-icon class="mr-1">mdi-weight-gram</v-icon>-->
                            <!--                                                        Gewicht:-->
                            <!--                                                        <span v-if="item.gram">{{item.gramm}}g</span>-->
                            <!--                                                        <span v-else>{{item.sizes[0].vol}}</span>-->
                            <!--                                                    </div>-->
                            <!--                                                    <div v-if="item.cmRatio" class="d-flex align-center">-->
                            <!--                                                        <v-icon>mdi-corn</v-icon>-->
                            <!--                                                        Getreidemischverhältnis: {{item.cmRatio}}-->
                            <!--                                                    </div>-->
                            <div v-if="item.days && $store.state.showItemDaysAvailability" class="pt-2">
                              <!--                                                                    <v-icon :color="itemAvailable() === true ? 'green' : 'red'" small>mdi-circle</v-icon>-->
                              Verfügbarkeit: {{ item.days | displayDays }}
                            </div>
                            <div class="notAvailable pt-2 pb-2" v-if="!buyable">
                              <template v-if="item.redAvailabilityInfo">
                                <span>{{ item.redAvailabilityInfo }}</span>
                              </template>
                              <template v-else>
                                <span v-if="!item.buyable">Der Artikel ist nicht online bestellbar</span>
                                <span v-else-if="$store.getters.inhouse && !item.buyableForInhouse">Der Artikel ist Inhouse nicht bestellbar</span>
                                <span v-else-if="!$store.getters.inhouse && !!item.buyableForInhouse">Der Artikel ist nur Inhouse bestellbar</span>
                                <span v-else>Der Artikel ist nicht online bestellbar</span>
                              </template>
                              <!--                <span v-else>Der Artikel ist für das gewählte Abholdatum nicht verfügbar</span>-->
                              <!--                ({{ item.filteredByAvailability}})-->
                            </div>
                          </v-flex>
                          <!--                          <v-flex xs6>-->
                          <!--                                                    <div v-if="!(item.verkauft || item.bestand < 1)">-->
                          <!--                                                        <v-icon color="green" small>mdi-circle</v-icon>-->
                          <!--                                                        Verfügbar-->
                          <!--                                                    </div>-->
                          <!--                                                    <div v-else>-->
                          <!--                                                        <v-icon color="red" small>mdi-circle</v-icon>-->
                          <!--                                                        Nicht Verfügbar-->
                          <!--                                                    </div>-->
                          <!--                                                    <div v-if="item.lieferzeit">Lieferzeit: {{item.lieferzeit}}</div>-->
                          <!--                          </v-flex>-->
                        </v-layout>
                        <!--                                    <span class="black-secondary">pro Stück</span>-->
                      </div>
                    </div>

                    <div class="spacer-15"></div>
                    <MyLine></MyLine>
                    <div class="spacer-15"></div>

                    <div v-if="item.sizes && item.sizes.length > 1">
                      <h4>Wähle deine Größe</h4>

                      <div class="n-marge">
                        <v-chip v-for="size in item.sizes"
                                class="ma-2"
                                active-class="primary"
                                :input-value="currentVol === size.vol"
                                @click.native.passive="switchSize(size.vol)"
                        >
                          <v-avatar left v-show="currentVol === size.vol">
                            <v-icon>mdi-check</v-icon>
                          </v-avatar>
                          {{ size | sizeDisplay }} <span v-if="!$store.getters.hidePrices">{{ size.price | priceTotal }}</span>
                        </v-chip>
                      </div>
                    </div>

                    <!--                            acivate for online-->
                    <div v-if="hasExtras && loaded" class="pt-3 fade-in">
                      <h4 id="extras">Deine Extras:</h4>
                      <div class="n-marge">
                        <v-chip class="ma-1"
                                v-for="extra in item.extras.styles"
                                :input-value="extra.aaaSelected"
                                active-class="primary"
                                @click.native.passive="switchExtra(extra)"
                        >
                          <v-avatar left v-show="extra.aaaSelected">
                            <v-icon>mdi-check</v-icon>
                          </v-avatar>
                          <span v-html="extra.labelDE"></span> <span class="ml-1"
                                                                     v-if="getExtraCost(extra) > 0">({{
                            extra | displayExtraPrice(currentVol)
                          }})</span>
                        </v-chip>
                      </div>
                    </div>

                    <!--                    TODO activate for online-->
                    <div v-if="hasVariants && loaded" id="variants" class="pt-3 fade-in">

                      <!--                            <div class="mb-4"-->
                      <!--                                 v-if="item.extras.combinations && selectedCat.categoryDE === 'Körperöle'">-->
                      <!--                                <router-link :to="{ name: 'Flaschenarten'}">Übersicht der Flaschenarten-->
                      <!--                                </router-link>-->
                      <!--                            </div>-->

                      <div v-for="(variant, index) in item.extras.variants"
                           v-show="variant.show"
                           v-bind:id="variant.aaaIndex">

                        <div class="variants">
                          <div class="spacer-15" v-if="index > 0"></div>

                          <div v-if="variant.dropdown" class="d-flex align-center bigger-input">
                            <!--                                        Mobile DROPWDOWN-->
                            <div style="min-width: 30vw; max-width: 50vw"
                                 v-if="!variant.ext">
                              <div v-html="variant.title"
                                   v-if="variant.title && variant.title.indexOf('<')!==-1"></div>
                              <h4 v-else>{{ variant.title }}</h4>
                            </div>
                            <div v-else>
                              <v-icon
                                :dark="!bgLight"
                                @click.native.passive="removeExtraPortion(index, variant.aaaIndex)"
                              >mdi-close-thick
                              </v-icon>
                            </div>
                            <div>
                              <div class="prelative">
                                <v-select :dark="!bgLight"

                                          outlined
                                          class="ml-4 dropdownSelect"
                                          v-model="selectModels['sm'+index]"
                                          :items="variant.options"
                                          item-text="aaaDisplayLabel"
                                          item-value="id"
                                          return-object
                                          single-line
                                          @input="selectDropdOption"
                                          @change="changeVariant(variant, index)"
                                          style="padding-top: 0"
                                          hide-details
                                >
                                  <!--                                        v-model="defaultSelected"-->
                                  <!--                                                    @see https://codepen.io/anon/pen/YBBJGr?&editors=101-->
                                  <template slot="item" slot-scope="data">
                                    <!-- HTML that describe how select should render items when the select is open -->
                                    <div v-html="data.item.aaaDisplayLabel"></div>
                                  </template>
                                  <template slot="selection" slot-scope="data">
                                    <!-- HTML that describe how select should render selected items -->
                                    <div class="text-no-wrap"><b>{{
                                        data.item |
                                          displayOptionWithoutSplits
                                      }}</b>
                                      <span
                                        v-if="data.item.cost">({{
                                          data.item.cost | displayOptionPrice(!!variant.replaceArticle)
                                        }})</span>
                                    </div>
                                  </template>
                                </v-select>
                                <div class="absSelects"
                                     v-if="!selectModels['sm'+index] || selectModels['sm'+index].id === ''"
                                     :class="{bgLight: bgLight}">
                                  <div class="superCenter">
                                    <span v-if="variant.optional">optional wählbar</span>
                                    <span v-else="">bitte wählen</span>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>

                          <div v-else>

                            <!-- Frage-->
                            <div v-html="variant.title"
                                 v-if="variant.title && variant.title.indexOf('<')!==-1"></div>
                            <h4 v-else>{{ variant.title }}</h4>
                            <div v-for="option in variant.options"
                                 @click.passive="selectOption(variant, option)"
                                 class="option pointer" :class="{selected: option.aaaSelected}">


                              <div class="d-flex">
                                <div v-if="variant.multi">
                                  <v-icon v-if="option.aaaSelected">
                                    mdi-check-box-outline
                                  </v-icon>
                                  <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                                </div>

                                <div v-else>
                                  <v-icon v-if="option.aaaSelected" :class="{invertIcon:!bgLight}">
                                    mdi-check-circle-outline
                                  </v-icon>
                                  <v-icon v-else>mdi-checkbox-blank-circle-outline :class="{invertIcon:!bgLight}">
                                  </v-icon>
                                </div>


                                <div style="padding-left: 3%" class="fasterGrow" v-html="option.labelDE">
                                </div>
                                <v-spacer></v-spacer>

                                <div style="float:right" v-if="!item.extras.combinations">
                                  {{
                                    option.cost |
                                      displayOptionPrice(!!variant.replaceArticle)
                                  }}
                                </div>

                                <div style="float:right"
                                     v-if="!$store.getters.hidePrices && item.extras.combinations && item.extras.variants.length === 1">
                                <span
                                  :class="{oprice: item.extras.combinations.find(c => c.id === option.id).streichPreis}">{{
                                    item.extras.combinations.find(c => c.id === option.id).price | price
                                  }}</span>
                                  <span v-if="item.extras.combinations.find(c => c.id === option.id).streichPreis"
                                        class="streichPreisCrossed ml-2">{{
                                      item.extras.combinations.find(c => c.id === option.id).streichPreis | price
                                    }}</span>
                                </div>
                              </div>
                            </div>
                            <div v-if="variant.optional && !variant.implicit"
                                 @click.passive="selectOhne(variant)"
                                 class="option pointer d-flex"
                                 :class="{selected: variant.aaaOhne}">
                              <v-icon v-if="variant.aaaOhne" :class="{invertIcon:!bgLight}">mdi-check-circle-outline</v-icon>
                              <v-icon v-else :class="{invertIcon:!bgLight}">mdi-checkbox-blank-circle-outline</v-icon>
                              <span style="padding-left: 3%">ohne</span>
                            </div>
                          </div>

                          <div v-if="variant.extendable && variant.showExtraPortion"
                               class="mt-3 mb-1 headColor"
                               style="font-size: 1.2em;"
                               @click.passive="addExtraPortion(variant.aaaIndex, index)"
                          >
                            <v-btn class="btn-mini">+ Extra Portion</v-btn>
                          </div>

                        </div>
                      </div>

                      <div class="spacer-20"></div>

                    </div>

                    <!--                            <div>Kategorie: <a :href="'/#/Produkte/'+encodeURIComponent(selectedCat.categoryDE)">{{selectedCat.categoryDE}}</a>-->
                    <!--                            </div>-->
                    <!--                            <div v-if="item.num && item.num.length > 0">Artikel-Nr.: {{item.num}}</div>-->
                  </v-flex>

                  <!--                        TODO activate for online-->
                  <v-flex xs12 v-if="loaded" class="fade-in">
                    <div class="d-flex" v-if="buyable">
                      <div class="flex-shrink-0 align-self-center">
                        <table v-if="!item.unikat">
                          <tr>
                            <td class="counterStuff minus" @click.passive="clickMinus">
                              <img :class="{invertImg: !bgLight}" src="../assets/icons/item-minus.png">
                            </td>
                            <td class="counter">{{ multiplicator }}</td>
                            <td class="counterStuff" @click.passive="clickPlus">
                              <img :class="{invertImg: !bgLight}" src="../assets/icons/item-plus.png">
                            </td>
                          </tr>
                        </table>
                      </div>
                      <add-to-cart-button
                        class="ml-3"
                        :noblink="noblink"
                        :small="true"
                        v-if="item.sizes && item.sizes.length > 0"
                        @click.native.passive="addToCart"
                        :total="0"></add-to-cart-button>
                    </div>
                    <div class="pt-4 itmExtras" v-if="$store.state.enableItemNote && buyable && loaded">
                      <v-text-field
                        v-model="item.notes"
                        placeholder="Anmerkung"
                        illed hide-details
                        class="nolabel panelField"
                        outlined
                        clearable
                        required
                      ></v-text-field>
                    </div>
                  </v-flex>

                  <v-flex x12>
                    <!--                            <div>inkl. MwSt. zzgl. Versandkosten</div>-->
                    <!--                            <div class="pt-3 pb-3">-->
                    <!--                                <v-icon :color="itemAvailable() === true ? 'green' : 'red'" small>mdi-circle</v-icon>-->
                    <!--                                Verfügbarkeit: {{item.days | displayDays}}-->
                    <!--                            </div>-->
                    <v-expansion-panels class="pt-5 panels"
                                        v-if="!item.ticket"
                                        style="overflow-x: hidden;">
                      <v-expansion-panel key="1" v-if="item.inhaltsstoffe">
                        <v-expansion-panel-header>Inhaltsstoffe</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div v-html="item.inhaltsstoffe"></div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel key="2" v-if="item.nutritions">
                        <v-expansion-panel-header>Nährwerte</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div v-html="item.nutritions"></div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel key="3">
                        <v-expansion-panel-header>Allergene & Zusatzstoffe
                        </v-expansion-panel-header>
                        <v-expansion-panel-content v-if="combinedAllergene">
                          <div v-html="combinedAllergene"></div>
                          <AllergenLegende
                            v-if="combinedAllergene && combinedAllergene.indexOf('<sup>')!== -1">
                          </AllergenLegende>
                        </v-expansion-panel-content>
                        <!--                                                                                                <v-expansion-panel-content v-if="allergennames.length > 0">-->
                        <!--                                                                                                    {{allergennames | stringList}}-->
                        <!--                                                                                                </v-expansion-panel-content>-->
                        <v-expansion-panel-content v-else>Dieser Artikel enthält keine Angaben zu
                          Allergenen
                          und
                          Zusatzstoffen
                        </v-expansion-panel-content>
                      </v-expansion-panel>

                    </v-expansion-panels>

                    <div class="pt-5">
                      <div class="d-flex">
                        <v-btn class="text-none btn-df accentBtn"
                               @click.native.passive="clickWeiter">
                          <div>Weiter Einkaufen</div>
                        </v-btn>
                        <v-btn class="ml-3 btn-df checkoutButtonAnimation text-none" v-if="showWeiter"
                               @click.native.passive="goCart">
                          CHECKOUT
                          <v-icon right medium>
                            mdi-chevron-right
                          </v-icon>
                        </v-btn>
                      </div>
                    </div>

                    <div class="spacer-20"></div>

                    <div v-if="itemClone">
                      <ItemDetailsTabs :item="itemClone"></ItemDetailsTabs>
                    </div>

                  </v-flex>
                </v-layout>


              </v-container>


              <div class="spacer-25"></div>

            </div>

            <div class="tablet">

              <!--            <div class="absBack">-->
              <!--                <div>-->
              <!--                    <v-icon onclick="window.history.back()" medium dark>mdi-arrow-left</v-icon>-->
              <!--                </div>-->
              <!--            </div>-->

              <div class="spacer-25"></div>
              <v-container grid-list-xl>
                <v-layout row wrap>
                  <!--                                style="flex-direction: row-reverse;"-->
                  <v-flex xs6 class="text-center text-sm-right text-md-center prelative">
                    <!--                        <div class="spacer-25 hidden-lg-and-up"></div>-->
                    <div class="product-image limited d-inline-block"
                         v-if="allImages.length > 0"
                         :class="{pointer: imgSource.indexOf('placeholder') === -1, hasmoreimages: hasMoreImages}"
                         @click.passive="clickImage">
                      <div class="prelative d-inline-block">
                        <!--                        <div class="stoerer abs" v-if="item.neu">NEU</div>-->
                        <!--                                            //TODO Zoom component-->
                        <!--                                            <image-zoom-->
                        <!--                                                    class="mainImage"-->
                        <!--                                                    :class="{pointer: imgSource.indexOf('placeholder') === -1}"-->
                        <!--                                                    :regular="imgSource"-->
                        <!--                                                    >-->
                        <!--                                            </image-zoom>-->
                        <img class="mainImage" :src="imgSource" alt=""
                             :class="{pointer: imgSource.indexOf('placeholder') === -1}">
                      </div>

                      <!--                                        :style="{ 'background-image': 'url(' + imgSource + ')' }">-->
                      <!--                            <div class="heart">-->
                      <!--                                <v-btn dark icon style="width: 50px; height: 50px"-->
                      <!--                                       @click.native.passive.stop="switchFavorite">-->
                      <!--                                    <v-icon x-large color="red" v-if="isFavorite">mdi-heart</v-icon>-->
                      <!--                                    <v-icon x-large v-else>mdi-heart-outline</v-icon>-->
                      <!--                                </v-btn>-->
                      <!--                            </div>-->
                      <div class="moreImagesLeft" v-if="hasMoreImages">
                        <!--                                <div class="d-flex">-->
                        <div class="moreImage"
                             :style="{ 'background-image': 'url(' + item.image + ')' }"
                             @click.passive.stop="currentSource =''; showLightbox = true"
                             @mouseover="currentSource =''"
                        ></div>
                        <div class="moreImage"
                             v-for="img of item.moreImages"
                             :style="{ 'background-image': 'url(' + img + ')' }"
                             @click.passive.stop="currentSource = img; showLightbox = true"
                             @mouseover="currentSource = img"
                        >
                        </div>
                        <!--                                </div>-->
                      </div>
                    </div>
                    <div v-if="hasKennzeichnung" class="text-right">
                      <div class="badge"
                           style="position: absolute; top: 11px; right: 5px;
}"
                      >
                        <img v-for="badge in badges"
                             class="mr-2"
                             :src="badge.src">
                      </div>
                    </div>

                    <div class="spacer-15" id="accordion"></div>
                    <div class="limited d-inline-block text-left">
                      <v-expansion-panels style="overflow-x: hidden;"
                                          class="panels"
                                          v-if="!item.ticket"
                      >
                        <v-expansion-panel key="1" v-if="item.inhaltsstoffe">
                          <v-expansion-panel-header>Inhaltsstoffe</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <div v-html="item.inhaltsstoffe"></div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel key="2" v-if="item.nutritions">
                          <v-expansion-panel-header>Nährwerte</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <div v-html="item.nutritions"></div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel key="3" @click="clickAccordion">
                          <v-expansion-panel-header>Allergene & Zusatzstoffe
                          </v-expansion-panel-header>
                          <v-expansion-panel-content v-if="combinedAllergene">
                            <div v-html="combinedAllergene"></div>
                            <AllergenLegende
                              v-if="combinedAllergene && combinedAllergene.indexOf('<sup>')!== -1">
                            </AllergenLegende>
                          </v-expansion-panel-content>
                          <!--                                                                                                <v-expansion-panel-content v-if="allergennames.length > 0">-->
                          <!--                                                                                                    {{allergennames | stringList}}-->
                          <!--                                                                                                </v-expansion-panel-content>-->
                          <v-expansion-panel-content v-else>Dieser Artikel enthält keine Angaben
                            zu Allergenen
                            und
                            Zusatzstoffen
                          </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel :key="index+4"
                                           v-for="(mg, index) in item.merkmalgruppen"
                                           v-if="item.merkmalgruppen">
                          <v-expansion-panel-header>{{ mg.name }}</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <div v-if="hasOnlyKeys(mg.keyValues)">
                              <div v-for="kv of mg.keyValues">{{ kv.key }}</div>
                            </div>
                            <div v-else class="d-flex" v-for="kv of mg.keyValues">
                              <div style="flex: 1 1 50%">
                                <span :class="{'pl-3': kv.params && kv.params.indent}">{{ kv.key }}</span>
                              </div>
                              <div style="flex: 1 1 50%" v-html="kv.value"></div>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>

                      </v-expansion-panels>
                    </div>
                  </v-flex>
                  <v-flex xs6>
                    <div class="d-flex">
                      <div>
                        <span v-if="item.neu" class="stoerer mr-2 superValign">NEU</span>
                        <h1 class="itemTitle d-inline withSup hyphens" style="font-size: 2em"
                            v-html="item.nameDE"></h1>
                        <span v-if="item.substances && item.substances.lAlk"><sup
                          class="alk supHigher"
                          :class="{bgLight:bgLight}">mit Alkohol</sup></span>
                      </div>
                      <div class="heart d-inline-block mr-2" v-if="$store.state.enableFavs">
                        <v-btn class="rounded100" dark icon style="width: 35px; height: 35px"
                               @click.native.passive.stop="switchFavorite">
                          <v-icon medium color="red" v-if="isFavorite">mdi-heart</v-icon>
                          <v-icon medium color="#888888" v-else>mdi-heart-outline</v-icon>
                        </v-btn>
                      </div>
                    </div>
                    <p class="pt-3" v-if="item.descriptionDE" v-html="item.descriptionDE"></p>
                    <div v-if="$store.state.enableBestand && $store.state.enableBestandanzeigeInItemList && item.bestand && item.bestand !== -1">
                      Bestand: {{item.bestand}}
                    </div>
                    <div v-if="item.gramm || item.sizes && item.sizes.length === 1 && item.sizes[0].vol"
                         class="d-flex align-center">
                      <!--                      <v-icon class="mr-1">mdi-weight-gram</v-icon>-->
                      <!--                      Gewicht:-->
                      <!--                      <span v-if="item.gram">{{ item.gramm }}g</span>-->
                      <span>{{ item.sizes[0].vol }}</span>
                    </div>
                    <div v-if="item.cmRatio" class="d-flex align-center">
                      <v-icon>mdi-corn</v-icon>
                      Getreidemischverhältnis: {{ item.cmRatio }}
                    </div>
                    <div v-if="item.days && $store.state.showItemDaysAvailability" class="pt-2">
                      <!--                                                                    <v-icon :color="itemAvailable() === true ? 'green' : 'red'" small>mdi-circle</v-icon>-->
                      Verfügbarkeit: {{ item.days | displayDays }}
                    </div>
                    <div class="notAvailable pt-2  pb-2" v-if="!buyable">
                      <template v-if="item.redAvailabilityInfo">
                        <span>{{ item.redAvailabilityInfo }}</span>
                      </template>
                      <template v-else>
                        <span v-if="!item.buyable">Der Artikel ist nicht online bestellbar</span>
                        <span v-else-if="$store.getters.inhouse && !item.buyableForInhouse">Der Artikel ist Inhouse nicht bestellbar</span>
                        <span v-else-if="!$store.getters.inhouse && !!item.buyableForInhouse">Der Artikel ist nur Inhouse bestellbar</span>
                        <span v-else>Der Artikel ist nicht online bestellbar</span>
                        <!--                <span v-else>Der Artikel ist für das gewählte Abholdatum nicht verfügbar</span>-->
                        <!--                ({{ item.filteredByAvailability}})-->
                      </template>
                    </div>

                    <!--                        <div v-if="item.sizes && item.sizes.length === 1 && item.sizes[0].vol">-->
                    <!--                            <v-icon>mdi-weight-gram</v-icon>-->
                    <!--                            Gewicht:-->
                    <!--                            {{item.sizes[0].vol}}-->
                    <!--                        </div>-->
                    <!--                        <div v-if="hasKennzeichnung">-->
                    <!--                            <div class="badge" v-for="badge in badges">-->
                    <!--                                <img :src="badge.src">-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                        <div v-if="item.num && item.num.length > 0">Artikel-Nr.: {{item.num}}</div>-->

                    <div class="spacer-15"></div>
                    <MyLine></MyLine>
                    <div class="spacer-15"></div>

                    <div v-if="item.sizes && item.sizes.length > 1">
                      <h4>Wähle deine Größe</h4>

                      <div class="n-marge">
                        <v-chip v-for="size in item.sizes"
                                class="ma-2"
                                active-class="primary"
                                :input-value="currentVol === size.vol"
                                @click.native.passive="switchSize(size.vol)"
                        >
                          <v-avatar left v-show="currentVol === size.vol">
                            <v-icon>mdi-check</v-icon>
                          </v-avatar>
                          {{ size | sizeDisplay }} <span v-if="!$store.getters.hidePrices">{{ size.price | priceTotal }}</span>
                        </v-chip>
                      </div>
                    </div>

                    <!--                        TODO activate for online-->
                    <div v-if="hasVariants && loaded" id="variants" class="pt-3 fade-in">
                      <!--                            <div class="mb-4" v-if="item.extras.combinations && selectedCat.categoryDE === 'Körperöle'">-->
                      <!--                                <router-link :to="{ name: 'Flaschenarten'}">Übersicht der Flaschenarten</router-link>-->
                      <!--                            </div>-->
                      <div v-for="(variant, index) in item.extras.variants"
                           v-show="variant.show"
                           v-bind:id="variant.aaaIndex">
                        <div class="variants">
                          <div class="spacer-15" v-if="index > 0"></div>

                          <div v-if="variant.dropdown" class="d-flex align-center bigger-input">
                            <!--                                        Mobile DROPWDOWN-->
                            <div style="flex: 0 0 40%"
                                 v-if="!variant.ext">
                              <div v-html="variant.title"
                                   v-if="variant.title && variant.title.indexOf('<')!==-1"></div>
                              <h4 v-else>{{ variant.title }}</h4>
                            </div>
                            <div v-else>
                              <v-icon
                                :dark="!bgLight"
                                @click.native.passive="removeExtraPortion(index, variant.aaaIndex)"
                              >mdi-close-thick
                              </v-icon>
                            </div>
                            <div style="flex: 0 0 60%">
                              <div class="prelative">
                                <v-select :dark="!bgLight"

                                          outlined
                                          class="ml-4 dropdownSelect"
                                          v-model="selectModels['sm'+index]"
                                          :items="variant.options"
                                          item-text="aaaDisplayLabel"
                                          item-value="id"
                                          return-object
                                          single-line
                                          @input="selectDropdOption"
                                          @change="changeVariant(variant, index)"
                                          style="padding-top: 0"
                                          hide-details
                                >
                                  <!--                                        v-model="defaultSelected"-->
                                  <!--                                                    @see https://codepen.io/anon/pen/YBBJGr?&editors=101-->
                                  <template slot="item" slot-scope="data">
                                    <!-- HTML that describe how select should render items when the select is open -->
                                    <div v-html="data.item.aaaDisplayLabel"></div>
                                  </template>
                                  <template slot="selection" slot-scope="data">
                                    <!-- HTML that describe how select should render selected items -->
                                    <div class="text-no-wrap"><b>{{
                                        data.item |
                                          displayOptionWithoutSplits
                                      }}</b>
                                      <span
                                        v-if="data.item.cost">({{
                                          data.item.cost | displayOptionPrice(!!variant.replaceArticle)
                                        }})</span>
                                    </div>
                                  </template>
                                </v-select>
                                <div class="absSelects"
                                     v-if="!selectModels['sm'+index] || selectModels['sm'+index].id === ''"
                                     :class="{bgLight: bgLight}">
                                  <div class="superCenter">
                                    <span v-if="variant.optional">optional wählbar</span>
                                    <span v-else="">bitte wählen</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div v-else>
                            <!-- Frage-->
                            <h4 v-html="variant.title"
                                v-if="variant.title && variant.title.indexOf('<')!==-1"></h4>
                            <h4 v-else>{{ variant.title }}</h4>
                            <div v-for="option in variant.options"
                                 @click.passive="selectOption(variant, option)"
                                 class="option pointer d-flex"
                                 :class="{selected: option.aaaSelected}">

                                        <span v-if="variant.multi">
                                            <v-icon v-if="option.aaaSelected">mdi-check-box-outline</v-icon>
                                            <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                                        </span>

                              <span v-else>
                                        <v-icon v-if="option.aaaSelected"
                                                :class="{invertIcon:!bgLight}">mdi-check-circle-outline</v-icon>
                                        <v-icon v-else :class="{invertIcon:!bgLight}">mdi-checkbox-blank-circle-outline</v-icon>
                                        </span>

                              <span style="padding-left: 3%;" class="fasterGrow"
                                    v-html="option.labelDE"></span>
                              <span style="float:right" v-if="!item.extras.combinations">
                                            {{ option.cost | displayOptionPrice(!!variant.replaceArticle) }}
                                        </span>
                              <span style="float:right"
                                    v-if="!$store.getters.hidePrices && item.extras.combinations && item.extras.variants.length === 1">
                                            <span
                                              :class="{oprice: item.extras.combinations.find(c => c.id === option.id).streichPreis}">{{
                                                item.extras.combinations.find(c => c.id === option.id).price | price
                                              }}</span>
                                            <span
                                              v-if="item.extras.combinations.find(c => c.id === option.id).streichPreis"
                                              class="streichPreisCrossed ml-2">{{
                                                item.extras.combinations.find(c => c.id === option.id).streichPreis | price
                                              }}</span>
                                        </span>
                            </div>
                            <div v-if="variant.optional && !variant.implicit"
                                 @click.passive="selectOhne(variant)"
                                 class="option pointer d-flex"
                                 :class="{selected: variant.aaaOhne}">
                              <v-icon v-if="variant.aaaOhne" :class="{invertIcon:!bgLight}">mdi-check-circle-outline</v-icon>
                              <v-icon v-else :class="{invertIcon:!bgLight}">mdi-checkbox-blank-circle-outline</v-icon>
                              <span style="padding-left: 3%">ohne</span>
                            </div>
                          </div>

                          <div v-if="variant.extendable && variant.showExtraPortion"
                               class="mt-3 mb-1 headColor"
                               style="font-size: 1.2em;"
                               @click.passive="addExtraPortion(variant.aaaIndex, index)"
                          >
                            <v-btn class="btn-mini">+ Extra Portion</v-btn>
                          </div>

                        </div>
                      </div>
                    </div>
                    <!--                        TODO activate for online-->
                    <div v-if="hasExtras && loaded" class="pt-3 fade-in">
                      <h4 id="extras">Deine Extras:</h4>
                      <div class="n-marge">
                        <v-chip class="ma-1"
                                v-for="extra in item.extras.styles"
                                :input-value="extra.aaaSelected"
                                active-class="primary"
                                @click.native.passive="switchExtra(extra)"
                        >
                          <v-avatar left v-show="extra.aaaSelected">
                            <v-icon>mdi-check</v-icon>
                          </v-avatar>
                          <span v-html="extra.labelDE"></span> <span class="ml-1"
                                                                     v-if="getExtraCost(extra) > 0">({{
                            extra | displayExtraPrice(currentVol)
                          }})</span>
                        </v-chip>
                      </div>
                    </div>


                    <div class="spacer-25" id="bottomAdd"></div>

                    <!--                        style="transform: scale(0.8); transform-origin: left top;"-->
                    <!--                        TODO remove when activate for online-->
                    <!--                        <div class="d-inline-block">-->
                    <!--                            <div class="mb-2">-->
                    <!--                                Preis: <span class="headline ml-2 mr-1">{{total | priceTotal}}</span>-->
                    <!--                                <span class="black-secondary">pro Stück</span>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                        TODO activate for online-->
                    <div class="d-inline-block">
                      <div>
                        <v-layout>
                          <v-flex xs12>
                            <div class="biggerFont" v-if="!$store.getters.hidePrices">Preis:
                              <span class="preis titleFont"
                                    :class="{oprice: item.streichPreis}">{{ total | priceTotal }}</span>
                              <span v-if="item.streichPreis"
                                    class="streichPreisCrossed ml-2">{{ item.streichPreis | price }}</span>
                            </div>
                            <div v-if="item.kilopreis && !$store.getters.hidePrices"><b>{{ item.kilopreis }}</b></div>
                            <div v-if="!$store.getters.hidePrices">inkl. MwSt.
                              <!--                                                        zzgl.-->
                              <!--                                                        <router-link @click.native.passive="jt"-->
                              <!--                                                                     :to="{ name: 'Lieferkosten' }"-->
                              <!--                                                        >Versand-->
                              <!--                                    </router-link>-->
                            </div>
                          </v-flex>
                          <v-flex xs6>
                            <!--                                                    <div v-if="!(item.verkauft || item.bestand < 1)">-->
                            <!--                                                        <v-icon color="green" small>mdi-circle</v-icon>-->
                            <!--                                                        Verfügbar-->
                            <!--                                            </div>-->
                            <!--                                                    <div v-else>-->
                            <!--                                                        <v-icon color="red" small>mdi-circle</v-icon>-->
                            <!--                                                        Nicht Verfügbar-->
                            <!--                                                    </div>-->
                            <!--                                                    <div v-if="item.lieferzeit">Lieferzeit: {{item.lieferzeit}}</div>-->
                          </v-flex>
                        </v-layout>

                        <!--                                <span class="black-secondary">pro Stück</span>-->
                      </div>
                      <div class="spacer-20"></div>
                      <div class="d-flex fade-in" v-if="buyable && loaded">
                        <div class="flex-shrink-0 align-self-center">
                          <table v-if="!item.unikat">
                            <tr>
                              <td class="counterStuff minus" @click.passive="clickMinus">
                                <img :class="{invertImg: !bgLight}" src="../assets/icons/item-minus.png">
                              </td>
                              <td class="counter">{{ multiplicator }}</td>
                              <td class="counterStuff" @click.passive="clickPlus">
                                <img :class="{invertImg: !bgLight}" src="../assets/icons/item-plus.png">
                              </td>
                            </tr>
                          </table>
                        </div>
                        <add-to-cart-button
                          class="ml-3"
                          :noblink="noblink"
                          v-if="item.sizes && item.sizes.length > 0"
                          @click.native.passive="addToCart"
                          :total="0"></add-to-cart-button>
                      </div>
                    </div>
                    <div class="pt-4 itmExtras fade-in" v-if="$store.state.enableItemNote && buyable && loaded">
                      <v-text-field
                        v-model="item.notes"
                        placeholder="Anmerkung"
                        illed hide-details
                        class="nolabel panelField"
                        clearable
                        required
                      ></v-text-field>
                    </div>

                    <!--                        <v-icon large @click.passive.native="clickMinus">mdi-minus-circle-outline</v-icon>-->
                    <!--                        {{multiplicator}}-->
                    <!--                        <v-icon large @click.passive.native="clickPlus">mdi-plus-circle-outline</v-icon>-->

                    <div class="spacer-15"></div>
                    <!--                        <div>inkl. MwSt. zzgl. Versandkosten</div>-->
                    <!--                        <div>-->
                    <!--                            <v-icon :color="itemAvailable() === true ? 'green' : 'red'" small>mdi-circle</v-icon>-->
                    <!--                            Verfügbarkeit: {{item.days | displayDays}}-->
                    <!--                        </div>-->
                    <!--                        <div>Kategorie: <a :href="'/#/Produkte/'+encodeURIComponent(selectedCat.categoryDE)">{{selectedCat.categoryDE}}</a>-->
                    <!--                        </div>-->
                    <div class="pt-5">
                      <div class="d-flex">
                        <v-btn class="text-none btn-df accentBtn"
                               @click.native.passive="clickWeiter">
                          <div>Weiter Einkaufen</div>
                        </v-btn>
                        <v-btn class="ml-3 btn-df checkoutButtonAnimation text-none" v-if="showWeiter"
                               @click.native.passive="goCart">
                          CHECKOUT
                          <v-icon right medium>
                            mdi-chevron-right
                          </v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>


            <!--        <v-container>-->
            <!--            <v-expansion-panels>-->
            <!--                <v-expansion-panel key="1" v-if="item.inhaltsstoffe">-->
            <!--                    <v-expansion-panel-header>Inhaltsstoffe</v-expansion-panel-header>-->
            <!--                    <v-expansion-panel-content>-->
            <!--                        <div v-html="item.inhaltsstoffe"></div>-->
            <!--                    </v-expansion-panel-content>-->
            <!--                </v-expansion-panel>-->
            <!--                <v-expansion-panel key="2">-->
            <!--                    <v-expansion-panel-header>Allergene & Zusatzstoffe</v-expansion-panel-header>-->
            <!--                    <v-expansion-panel-content v-if="allergennames.length > 0">-->
            <!--                        {{allergennames | stringList}}-->
            <!--                    </v-expansion-panel-content>-->
            <!--                    <v-expansion-panel-content v-else>Dieser Artikel enthält keine Angaben zu Allergenen und-->
            <!--                        Zusatzstoffen-->
            <!--                    </v-expansion-panel-content>-->
            <!--                </v-expansion-panel>-->
            <!--            </v-expansion-panels>-->
            <!--        </v-container>-->

            <!--        <div class="moreTitle text-center"><h2>Weitere {{currentCategory}}</h2></div>-->

            <!--                <div class="moreTitle text-center"><h2>{{currentCategory}}</h2></div>-->
            <!--                <div class="mobile">-->
            <!--                    <MySlider3 v-if="loaded"-->
            <!--                               :current-item-id="currentItemId"-->
            <!--                               :cat-name="currentCategory"></MySlider3>-->
            <!--                </div>-->

            <!--                <div class="tablet">-->
            <!--                    <v-container>-->
            <!--                        <MySlider3 v-if="loaded"-->
            <!--                                   :current-item-id="currentItemId"-->
            <!--                                   :cat-name="currentCategory"></MySlider3>-->
            <!--                    </v-container>-->
            <!--                </div>-->

            <div class="spacer-40"></div>

            <div class="lightbox d-flex justify-center align-center maxh"
                 @click.passive="showLightbox = false"
                 v-if="showLightbox">

              <div class="inner" v-if="hasMoreImages" style="height: 95%; max-height: 1000px;">
                <v-carousel
                  @click.native.passive.stop=""
                  height="100%"
                  hide-delimiter-background
                  v-model="sliderKey"
                  style="background: transparent"
                >
                  <!--                    <v-carousel-item :key="1">-->
                  <!--                        <v-sheet-->
                  <!--                                @click.native.passive="showLightbox = false"-->
                  <!--                                height="100%" :style="{ 'background-image': 'url(' + item.image + ')' }">-->
                  <!--                        </v-sheet>-->
                  <!--                    </v-carousel-item>-->
                  <v-carousel-item v-for="(mi, index) in allImages" :key="index + 1">
                    <v-sheet
                      @click.native.passive="showLightbox = false"
                      height="100%">
                      <div class="sliderImg" :style="{ 'background-image': 'url(' + mi + ')' }"></div>
                    </v-sheet>
                  </v-carousel-item>
                </v-carousel>
                <div class="close pointer" @click.passive="showLightbox = false">
                  <v-icon color="white" large>mdi-close-thick</v-icon>
                </div>
              </div>

              <div class="inner" v-else>
                <v-img
                  :src="imgSource"
                  contain
                  position="center top"
                  style="width: auto; max-width: var(--layout-width); max-height: 90vh; height: 90vh"
                />
                <div class="close pointer" @click.passive="showLightbox = false">
                  <v-icon color="white" large>mdi-close-thick</v-icon>
                </div>
              </div>
            </div>

            <!-- only for iframe -->
            <v-container>
              <div v-if="itemClone">
                <ItemDetailsTabs class="tablet" :item="itemClone"></ItemDetailsTabs>
              </div>

              <MyLine class="mt-4 mb-4"></MyLine>

              <DrinkCards v-if="!isTicketCategory()"></DrinkCards>
            </v-container>


          </v-flex>

          <v-flex class="hidden-sm-and-down" xs12 md4>
            <Warenkorb></Warenkorb>
          </v-flex>
        </v-layout>
      </v-container>

      <!--        <div class="absBack" style="top: 137px;">-->
      <!--            <div onclick="window.history.back()">-->
      <!--                <v-icon medium dark>mdi-arrow-left</v-icon>-->
      <!--            </div>-->
      <!--        </div>-->

      <!--        :selected-cat="selectedCat" :cats="foodCategories"-->
      <!--        <cat-slider-->
      <!--                @selectCat="selectCategory"></cat-slider>-->

      <!--        <div class="catSlider">-->
      <!--            <v-slide-group show-arrows>-->
      <!--                <v-slide-item-->
      <!--                        v-for="cat in foodCategories"-->
      <!--                        :key="cat.id"-->
      <!--                >-->
      <!--                    &lt;!&ndash;                    v-slot:default="{ active, toggle }"&ndash;&gt;-->
      <!--                    <v-btn-->
      <!--                            large-->
      <!--                            dark-->
      <!--                            tile-->
      <!--                            class="myBtn"-->
      <!--                            :input-value="selectedCat.id === cat.id"-->
      <!--                            active-class="catActive white&#45;&#45;text"-->
      <!--                            @click.native.passive="selectCategory(cat)"-->
      <!--                    >-->
      <!--                        {{ cat.categoryDE }}-->
      <!--                    </v-btn>-->
      <!--                </v-slide-item>-->
      <!--            </v-slide-group>-->
      <!--        </div>-->

      <!--        <div class="spacer-30"></div>-->

      <!--        <div class="spacer-25 tablet" style="height: 60px"></div>-->


      <FixBasket></FixBasket>

    </div>
  </div>
</template>

<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import * as util from '../vendor/util'
// import * as plausi from '../vendor/plausi'
import * as itemUtil from '../vendor/itemUtil'
import * as qconst from '../vendor/qconstants'
import {subs} from "../vendor/subs";
// import {gevent} from "../firebase/firebaseUtil";
import {incAndGetItemsCount, resetItemsCount} from "../vendor/appManager";

import AddToCartButton from "../components/AddToCartButton";
import {offerMixin} from "../mixins/offerMixin";
// import MySlider2 from "../components/MySlider2";
// import MySlider3 from "../components/MySlider3";
// import CatSlider from "../components/CatSlider";
import FixBasket from "../components/FixBasket";
import SortimentCards from "../components/SortimentCards";
import MyLine from "../components/MyLine";
import ItemDetailsTabs from "../components/ItemDetailsTabs";
import Warenkorb from "../components/Warenkorb";
import DrinkCards from "../components/DrinkCards";
import AllergenLegende from "../components/AllergenLegende";
import CatSlider from "@/components/CatSlider.vue";
import {setGlobalKeyValue} from "../util/globalState";
import {cloneMe} from "../vendor/util";
// import imageZoom from 'vue-image-zoomer';

export default {
  name: 'DrinkItemDetail',
  // metaInfo() {
  //     return {
  //
  //         title: this.item.nameDE + ' - Kikis Deko- und Aromashop',
  //         meta: [
  //             {
  //                 name: 'description',
  //                 content: 'Informationen zum Produkt: ' + this.item.nameDE + ' ' + this.item.descriptionDE
  //             },
  //             {property: 'og:title', content: this.item.nameDE + ' - Kikis Deko- und Aromashop'},
  //             {property: 'og:site_name', content: 'Kikis Deko- und Aromashop'},
  //             {
  //                 property: 'og:description',
  //                 content: 'Informationen zum Produkt: ' + this.item.nameDE + ' ' + this.item.descriptionDE
  //             },
  //             {property: 'og:type', content: 'product'},
  //             {property: 'og:url', content: window.location.href},
  //             {property: 'og:image', content: '' + this.item.image}
  //         ]
  //     }
  // },
  mixins: [offerMixin],
  components: {
    CatSlider,
    AllergenLegende,
    Warenkorb,
    DrinkCards,
    ItemDetailsTabs,
    MyLine,
    SortimentCards,
    FixBasket,
    AddToCartButton,
  },
  props: {
    addDirectly: {
      type: Boolean,
      default: false
    },
    itemId: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      renderSearch: false,

      bgLight: true,

      selectModels: {
        // 'indexOfVariant in item.extras' :  {id: 'id of option that has aaaSelected'},
        //   'indexOfVariant in item.extras' : {id: 'id of option that has aaaSelected'},
      },

      showWeiter: false,

      previousCanonical: '',

      sliderKey: 0,
      showLightbox: false,
      currentSource: '',

      badges: [],//veggi...

      selectedCat: {id: '0', categoryDE: '', delay: 0, type: 'drink'},
      // foodCategories: [],
      item: Object,
      itemToAdd: null,

      noblink: false,
      selection: 2,

      loaded: false,
      // showBigImage: false,
      showAnyImage: true,
      substances: {},

      currentVol: '',
      currentItemId: '',
      isFavorite: false,
      total: 0,

      combiPrice: 0, // only used for combinations
      replacePrice: 0,//only used for steps with replaceArticle
      multiplicator: 1,
      fulltotal: 0,


      allergennames: [],
      combinedAllergene: '',

      emitSome: false,

      currentOption: null,

      displayOfferText: '',
    }
  },
  watch: {
    '$route.params.itemId'(id) {
      if (id && id !== this.currentItemId) {
        console.log('watched itemId change to ' + id);
        this.currentItemId = '' + id;
        this.currentSource = '';
        this.fullInit();
      }
    },
    currentSource(newValue) {
      console.log('changeCurrentSource to ' + newValue);
      if (newValue === '') {
        this.sliderKey = 0;
      } else {
        if (this.hasMoreImages) {
          let i = 0;
          for (let mi of this.allImages) {
            if (mi === this.currentSource) {
              this.sliderKey = i;
              return;
            }
            ++i;
          }
        }
      }

    }
  },
  computed: {
    buyable() {
      let a = (!('buyable' in this.item) || this.item.buyable) && this.item.withinOrderTimes;
      let b = store.getters.inhouse ? this.item.buyableForInhouse : this.item.buyableForTakeaway;
      return a & b;
    },
    orderingEnabled() {
      return !!store.getters.selectedStore.orderingEnabled;
    },
    itemClone() {
      if (this.item && !util.isEmptyObject(this.item)) {
        return util.cloneMe(this.item);
      }
      return false;
    },
    hasKennzeichnung() {
      return this.badges.length > 0;
    },
    hasMoreImages() {
      return this.item.moreImages && (this.item.moreImages.length > 0);
    },
    allImages() {
      let all = [];
      try {
        if (this.item.image) {
          all.push(this.item.image);
        }
        if (this.item.moreImages) {
          for (let m of this.item.moreImages) {
            all.push(m);
          }
        }
        if (all.length === 0) {
          all.push(require('@/assets/placeholder6-opti.png'));
        }
      } catch (e) {

      }
      return all;
    },
    imgSource() {
      let src = '';

      if (this.currentSource.length > 0) {
        src = '' + this.currentSource;
      } else if (this.item.image && this.item.image.length > 0) {
        src = this.item.image;
      } else {
        // if (store.state.showPlaceholders) {
        src = require('@/assets/placeholder6-opti.png');
        // }
      }

      // // if (typeof this.item === 'undefined' || !'image' in this.item) {
      // //     this.showBigImage = true;
      // //     return require('@/assets/dummyDrink.png')
      // // }
      // // if (this.item.image && this.item.image.sourceBig && this.item.image.sourceBig.length > 0) {
      // //     src = this.item.image.sourceBig;
      // //     this.showBigImage = true;
      // // } else
      // if (this.item.image && this.item.image.source && this.item.image.source.length > 0) {
      //     src = this.item.image.source;
      //     // this.showBigImage = false;
      // }

      console.log('??? image src = ' + src);

      if (src.length > 0) {
        this.showAnyImage = true;
        return src;
      }

      this.showAnyImage = false;
      return '';
      // this.showBigImage = true;
      // return require('@/assets/pizza-pasta.webp');
      // return require('@/assets/heinz.jpg');
      // return require('@/assets/dummyDrink.png')
    },

    hasVariants() {
      return this.item && this.item.extras && this.item.extras.variants && this.item.extras.variants.length > 0;
    },

    hasExtras() {
      return this.item.extras && this.item.extras.styles && this.item.extras.styles.length > 0;
    },

    hasDescription() {
      return this.item.descriptionDE && this.item.descriptionDE.length > 0;
    }
  },
  created() {
    ebus.$on(qconst.notify$drinksUpdated, (param) => {
      if (Object.keys(this.item) < 4 || (param && param.force)) {
        console.log('ItemDetail drinkUpdated keys < 4');
        this.fullInit();
        // this.initSlider();
      } else {
        console.log('ItemDetail drinkUpdated keys >= 4');
      }
    });
    ebus.$on('userOrderModeSwitchUpdated', () => {
      if (this.itemToAdd) {
        this.addToCart();
      }
    });
    ebus.$on('offersUpdated', () => {
      this.init();
    });
    ebus.$on('favoritesUpdated', () => {
      this.updateFavoriteIcon(false);
    });


    ebus.$on('questionClosed', () => {
      this.itemAddedEvent();
    });

  },
  beforeMount() {
    this.prepareSelecModels();
  },
  mounted() {
    console.log('??? detail mounted...');
    try {
      if (this.itemId) {
        this.currentItemId = '' + this.itemId;

        this.multiplicator = 1;

        this.fullInit();
      } else {
        if (this.$store.getters.showDialogContainer) {
          this.currentItemId = '' + this.$store.getters.currentItemId;

          this.multiplicator = 1;

          this.fullInit();
        } else {
          this.fullInit();
          //preselect cartItem
          let cartItem = this.findCartItem();
          if (cartItem) {
            this.preselectExtras(cartItem.variantsSelected, cartItem.stylesSelected);
            if (cartItem.vol) {
              this.switchSize(cartItem.vol);//triggers updateTotal
              // this.currentVol = cartItem.vol;
            }
          }
        }
      }
      setTimeout(() => {
        this.initAllergens();
      }, 800);//after init

      if (this.addDirectly) {
        this.multiplicator = 1;
        this.addToCart();
      } else {
        this.$nextTick(() => {
          this.renderSearch = true;
        });
      }

    } catch (e) {
      console.log('error in mounted: ' + e.message);
    }
  },

  activated() {
    console.log('??? detail activated...');
    if (this.itemId) {
      this.currentItemId = '' + this.itemId;
    } else {
      if (this.$store.getters.showDialogContainer) {
        this.currentItemId = '' + this.$store.getters.currentItemId;
        console.log('currentItemId = ' + this.currentItemId);
      }
    }
    this.showWeiter = false;
    // this.showBigImage = false;
    this.displayOfferText = '';
    this.currentSource = '';
    this.sliderKey = 0;
    this.multiplicator = 1;
    if (Object.keys(this.item) < 4 || this.$store.getters.showDialogContainer) {
      this.fullInit();
    } else {
      // console.log('activated ItemDetail ',util.cloneMe(this.item.extras));

      //preselect cartItem
      let cartItem = this.findCartItem();
      if (cartItem) {
        this.preselectExtras(cartItem.variantsSelected, cartItem.stylesSelected);
        if (cartItem.vol) {
          this.switchSize(cartItem.vol);//triggers updateTotal
          // this.currentVol = cartItem.vol;
        }
      }

      this.updateFavoriteIcon(true);

      this.item = util.filteredExtras(util.cloneMe(this.item));//force model update!!

      this.preselectSingleVariant();

      this.updateTotal();
    }

    setTimeout(() => {
      this.initAllergens();
    }, 400);

    this.updateSelectModels();
    this.updateMetadata();
  },

  destroyed() {
    console.log('deactivated details');
    util.clearEvents([
      qconst.notify$drinksUpdated,
      'userOrderModeSwitchUpdated',
      'offersUpdated',
      'deviceClassesUpdated',
      'favoritesUpdated',
      'questionClosed',
    ]);
    // this.loaded = false;
    this.currentSource = '';
    if (this.emitSome) {
      this.emitSome = false;
      resetItemsCount();
      ebus.$emit('viewedSomeItems');
    }

    this.deselectAllOptions();
    // try {
    //     let c = window.document.querySelector('link[rel="canonical"]');
    //     c.setAttribute('href', '' + this.previousCanonical);
    // } catch (e) {
    //     console.log('Error in deactivated: ' + e.message);
    // }


    // this.currentCategory = '';
  },

  methods: {
    hasOnlyKeys(keyValues) {
      if (!keyValues) {
        return true;
      }
      let anyValue = keyValues.find(i => !!i.value);
      return !anyValue;
    },
    isTicketCategory() {
      return this.selectedCat.categoryDE.toLowerCase().indexOf('ticket') !== -1;
    },

    selectCategory(cat) {
      // store.commit('selectedCategoryId', cat.id);
      store.state.shouldJump = true;
      this.$router.push({name: 'SpeisenProdukte', params: {catname: cat.categoryDE}});
    },

    prepareSelecModels() {
      //stepIndexes
      for (let s = 0; s < 300; s++) {
        //selectModelindex
        this.selectModels['sm' + s] = {
          id: '',
        };
      }
    },
    deselectAllOptions() {
      if (this.item.extras && this.item.extras.variants) {
        for (let variant of this.item.extras.variants) {
          if (variant.options) {
            for (let option of variant.options) {
              option.aaaSelected = false;
            }
          }
        }
        this.updateSelectModels();
      }
    },
    resetShowExtraPortion(aaaIndex) {
      try {
        let extNum = 0;
        let i = -1;
        let lastIdx = -1;
        for (let step of this.item.extras.variants) {
          ++i;
          if (step.aaaIndex === aaaIndex) {
            lastIdx = i;
            step.showExtraPortion = false;
            console.log('disable showExtraPortion for aaaIndex' + aaaIndex);

            if (step.ext) {
              extNum += 1;
              step.aaaNumberOfExt = extNum;
            }
          }
        }
        // console.log('lastIdx = '+lastIdx);
        if (lastIdx !== -1) {
          this.item.extras.variants[lastIdx].showExtraPortion = true;
        }
        console.log('reset extra portions ' + extNum + " times");
      } catch (e) {

      }
    },
    addExtraPortion(aaaIndex, index) {
      let itm = util.cloneMe(this.item);

      let x = itm.extras.variants.find(v => v.aaaIndex === aaaIndex);
      if (x) {
        let extraPortion = util.cloneMe(x);
        extraPortion.title = '';
        extraPortion.multi = false;
        extraPortion.dropdown = true;
        extraPortion.ext = true;
        extraPortion.aaaNumberOfExt = 0; //will be overwritten by reset method
        extraPortion.showExtraPortion = true;
        for (let option of extraPortion.options) {
          option.aaaSelected = false;
        }

        // this.selectModels['sm' + (index + 1)] = {
        //     id: -1,
        // };
        itm.extras.variants.splice((index + 1), 0, extraPortion);

        //move the rest of selectModels to index+1
        let smClone = util.cloneMe(this.selectModels);
        for (let i = 0; i < Object.keys(this.selectModels).length - 1; i++) {
          try {
            if (i < index) {
              continue;
            }
            let vNext = smClone['sm' + i];
            if (vNext) {
              this.selectModels['sm' + (i + 1)] = vNext;
              console.log('set sm' + (i + 1) + ' to ' + vNext.id);
            }
          } catch (e) {
            console.log('error in moving selectModels to index+1: ' + e.message);
          }
        }

        this.item = util.filteredExtras(itm);

        this.resetShowExtraPortion(aaaIndex);

        this.updateSelectModels();

      } else {
        console.log('Error: Variant not found with index ' + stepIndex);
      }
    },
    updateSelectModels() {
      //INPUT: this.item variatns options.aaaSelected
      //OUTPUT: update selected Id in selectModels
      try {
        let index = 0;
        if (!this.item.extras || !this.item.extras.variants) {
          return;
        }
        for (let variant of this.item.extras.variants) {
          if (variant.options) {
            let id = '';
            for (let option of variant.options) {
              if (option.aaaSelected) {
                id = option.id;
              }
            }
            this.selectModels['sm' + index] = {id: id};
            console.log('updateSelectModesl ' + 'sm' + index + ' => ' + this.selectModels['sm' + index].id);
          }
          ++index;
        }
      } catch (e) {
        console.log('Error in updateSelectModels: ' + e.message);
      }
    },
    removeExtraPortion(index, aaaIndex) {
      this.item.extras.variants.splice(index, 1);
      this.resetShowExtraPortion(aaaIndex);

      console.log('item variants remove sneak 3 : ', this.item.extras.variants);

      this.updateSelectModels();
    },
    itemAddedEvent() {
      this.$emit('wasAdded');
    },
    getExtraCost(extra) {
      return util.getExtraPrice(extra, this.currentVol);
    },
    updateMetadata() {
      // try {
      //     let c = window.document.querySelector('link[rel="canonical"]');
      //     console.log('updateMetadata canonical = ' + c);
      //
      //     this.previousCanonical = c.href;
      //     c.setAttribute('href', window.location.href);
      //
      //     console.log('Canonical set to ' + window.location.href);
      //
      // } catch (e) {
      //     console.log('Error in updateMetadata: ' + e.message);
      // }
    },
    // share() {
    //     let title = store.state.brandName;
    //     let text = '' + this.item.nameDE;
    //     let shareUrl = window.location.href;
    //
    //     // let user = firebaseUtil.getUser();
    //     // if (user) {
    //     //     text = 'Sichere dir jetzt Coupons für ' + store.state.brandName;
    //     //     // + sichern! '+user.displayName+' lädt dich ein, die Bestell-App für ' +store.state.brandName+' zu probieren!';
    //     // }
    //
    //     try {
    //         window.navigator.share({
    //             title: title,
    //             text: text,
    //             url: shareUrl,
    //         }); // share the URL of MDN
    //     } catch (e) {
    //         console.log('Error in shareApp: ' + e.message);
    //         //use email instead
    //         let body = 'Alle Informationen zum Produkt: ' + text + ':\n \n' +
    //             shareUrl;
    //         body = encodeURIComponent(body);
    //         text = encodeURIComponent(text);
    //         let mailto_link = 'mailto:?subject=' + text + '&body=' + body;
    //         let win = window.open(mailto_link);//, '_blank');
    //         win.focus();
    //     }
    // },
    getAnalyticsItem(quantity, selectedVol) {
      let gItem = {
        item_id: this.item.id,
        item_name: this.item.nameDE,
        price: this.total,
        quantity: this.multiplicator,
        item_category: this.selectedCat.categoryDE,
        // item_brand_ ''
      };
      if (quantity) {
        gItem.quantity = quantity;
      }
      if (selectedVol) {
        gItem.item_variant = selectedVol;
      }
      return gItem;
    },
    fullInit() {
      console.log('fullInit');
      this.init();
      // this.initSlider();
      this.initAllergens();
      setTimeout(() => {
        // util.jumpToTop();
        ebus.$emit('showScrollDown', true);
      }, 110);
      this.noblink = false;

      if (incAndGetItemsCount() > 4) {
        this.emitSome = true;
      }

      //https://firebase.google.com/docs/reference/android/com/google/firebase/analytics/FirebaseAnalytics.Event#VIEW_ITEM
      // gevent('view_item', {
      //     currency: 'EUR',
      //     value: this.total,
      //     //https://firebase.google.com/docs/reference/js/firebase.analytics.Item
      //     items: [this.getAnalyticsItem(1)]
      // });
    },
    // itemAvailable() {
    //     return plausi.itemAvailableTomorrow(this.item);
    // },
    // clickSortiment() {
    //     this.$router.push({name: 'Sortiment'});
    // },
    init() {
      // this.showMoreSlider = false;
      // setTimeout(() => {
      //     this.showMoreSlider = true;
      // }, 600);
      this.loaded = false;
      // this.badges = [];
      // if (!this.hasCartItemQuery()
      //     && !util.isEmptyObject(this.item)
      //     && this.currentItemId === this.$route.params.drinkId) {
      //     return;
      // }
      this.showLightbox = false;
      this.showAnyImage = true;

      this.currentVol = '';
      // let restName = '' + store.state.restaurantData.restaurantName;
      // store.commit('headerTitle', restName);

      let theItemId = '';
      if (this.$store.getters.showDialogContainer) {
        theItemId = '' + this.$store.getters.currentItemId;
        this.currentItemId = '' + theItemId;
        console.log('currentItemId = ' + theItemId);
      } else {
        theItemId = this.$route.params.itemId;
        if (this.addDirectly) {
          theItemId = this.currentItemId;
        } else {
          this.currentItemId = '' + theItemId;
        }
      }

      console.log('??? detail theItemId =  ' + theItemId);

      if (!theItemId) {
        return;
      }

      let itemInStore = store.getters.getDrinkById(theItemId);
      if (!itemInStore) {
        return;
      }

      //preselect category
      if (!store.state.duringCatSelect) {
        let cat = store.getters.getDrinkCategoryByItemId(theItemId);
        cat.type = 'drink';
        this.selectedCat.id = '' + cat.id;
        this.selectedCat.categoryDE = '' + cat.categoryDE;
        this.selectedCat.delay = cat.delay ? parseInt(cat.delay, 10) : 0;
        store.commit('selectedCategory', cat);
      }

      let item = util.cloneMe(itemInStore);
      for (let size of item.sizes) {
        size['aaaCount'] = 0; //user selection
      }
      let offerAndItem = store.getters.getOfferByItemId(item.id);
      item.offered = !!offerAndItem;
      if (item.offered) {
        item.offerId = offerAndItem.offer.id;
        this.displayOfferText = offerAndItem.offer.name;
      }
      this.applyOfferAndPrices(item, offerAndItem);

      // if (!item.image) {
      //     item.image = require('@/assets/placeholder6-opti.jpg');
      // }

      if (item.extras) {
        if (item.extras.styles) {
          for (let extra of item.extras.styles) {
            //add aaaSelected
            extra.aaaSelected = false;
          }
        }

        if (item.extras.variants) {
          // && d.extras.variants.options
          let variantIndex = 1;
          for (let variant of item.extras.variants) {
            if (variant.title === 'Schritt') {
              variant.title = 'Optionen';
            }
            variant.aaaIndex = 'step-' + variantIndex++;
            variant.show = !this.isDynamic(variant);
            variant.aaaOhne = false;
            variant.showExtraPortion = variant.extendable;
            if (variant.options) {
              for (let option of variant.options) {
                option.aaaSelected = false;
                // option.cost | displayOptionPrice(!!variant.replaceArticle)
                let displayCost = this.$options.filters.displayOptionPrice(option.cost, !!variant.replaceArticle);
                if (displayCost) {
                  displayCost = ' (' + displayCost + ')';
                }
                let nameAndDescription = '';
                if (option.labelDE.indexOf('|') > 0) {
                  let splits = option.labelDE.split('|');
                  let first = true;
                  for (let split of splits) {
                    if (first) {
                      first = false;
                      nameAndDescription += '<b>' + split.trim() + displayCost + '</b>';
                    } else {
                      nameAndDescription += '<br>' + split.trim();
                    }
                  }
                } else {
                  nameAndDescription = '<b>' + option.labelDE + displayCost + '</b>';
                }
                option.aaaDisplayLabel = '<div class="mt-1 mb-1">' + nameAndDescription + '</div>';
              }
            }
          }
        }
      }

      this.item = util.filteredExtras(item);

      this.preselectSingleVariant();

      let subs = {};
      if ('substances' in this.item) {
        subs = util.cloneMe(this.item.substances);
      }
      this.substances = subs;
      // Object.assign(this.substances, subs);

      //preselect values from cartItem
      let cartItem = this.findCartItem();
      if (cartItem && cartItem.vol) {
        this.currentVol = cartItem.vol;
      } else {
        let favItem = this.findFavItem();
        if (favItem && favItem.vol) {
          this.currentVol = favItem.vol;
        }
      }

      // this.updateTotal();
      this.updateFavoriteIcon(true);
      this.tryIncrement(item);
      setTimeout(() => {
        this.loaded = true;
      }, 80);
    },

    // initSlider() {
    //     let drinkCats = util.cloneMe(store.getters.drinkMenu);
    //     // console.log('so do we have cats??? ' + drinkCats.length);
    //     for (let fcat of drinkCats) {
    //         if (!fcat.items) {
    //             continue;
    //         }
    //         for (let item of fcat.items) {
    //             let offerAndItem = store.getters.getOfferByItemId(item.id);
    //             // item.offered = !!offerAndItem;
    //             // if (!!offerAndItem) {
    //             //     item.offerId = offerAndItem.offer.id;
    //             // }
    //             this.applyOfferAndPrices(item, offerAndItem);
    //         }
    //     }
    //     this.drinkCategories = drinkCats;
    //     // this.loaded = true;
    // },
    initAllergens() {
      try {
        console.log('initAllergens...');
        this.allergennames = [];
        this.combinedAllergene = '';
        let theSubs = {};
        // console.log('??? allergens init...');
        this.badges = [];
        if ('substances' in this.item) {
          console.log('??? has substances = true');

          Object.keys(this.item.substances).forEach((key) => {
            console.log(key);
            if (key === 'lV') {
              this.addBadge('vegi');
            } else if (key === 'lVplus') {
              this.addBadge('vegan-140');
            } else if (key === 'lBIO') {
              this.addBadge('bio');
            } else if (key === 'lKOSCH') {
              this.addBadge('koscher');
            } else if (key === 'lAy') {
              this.addBadge('ayurveda');
            } else if (key === 'lHal') {
              this.addBadge('halal');
            }
          });

          // console.log('??? allergens has substances...');
          theSubs = util.cloneMe(this.item.substances);
          console.log('??? this subs ' + JSON.stringify(theSubs));
          let _names = [];
          for (let x in theSubs) {
            if (x.substring(0, 1) === 'l') {
              continue;
            }
            // console.log('??? allergene x='+x);
            if (theSubs[x] && subs[x]) {
              _names.push(subs[x]);
            }
          }
          this.allergennames = _names;
        } else {
          console.log('??? has substances = false');
        }

        let a = this.$options.filters.stringList(this.allergennames);
        if (a) {
          this.combinedAllergene = a;
        }
        let combiCustomAndPosAllergens = (this.item.customAllergene || '') + ' ' + (this.item.allergens || '');
        if (combiCustomAndPosAllergens.length > 1) {
          if (a) {
            this.combinedAllergene = a + '<br>' + combiCustomAndPosAllergens;
          } else {
            this.combinedAllergene = '' + combiCustomAndPosAllergens;
          }
        }

        this.combinedAllergene = util.spacifyString(this.combinedAllergene);

      } catch (e) {
        console.log('error in initAllergens ', e);
      }
    },

    addBadge(imgName) {
      console.log('addBadge ' + imgName);
      this.badges.push({src: require('@/assets/icons/' + imgName + '.png')});
    },

    clickMobileImage() {
      if (this.item.moreImages && this.item.moreImages.length > 0) {
        this.currentSource = this.item.moreImages[0];
        this.sliderKey = 1;
      }
      if (!this.imgSource.includes('placeholde')) {
        this.showLightbox = true;
      }
    },
    clickImage() {
      if (!this.imgSource.includes('placeholder')) {
        this.currentSource = this.imgSource;
        this.showLightbox = true;
      }
    },


    clickAccordion() {
      // util.delayScroll('accordion');
    },

    clickWeiter() {
      ebus.$emit('goBack');
      // store.state.shouldJump = false;
      // this.$router.push({name: 'Speisen', params: {catname: this.selectedCat.categoryDE}});
    },

    goCart() {
      if (this.$store.getters.showDialogContainer) {
        this.$store.commit('showDialogContainer', false);
      }
      this.$router.push({name: 'Korb'});
    },

    // selectCategory(cat) {
    //     // store.commit('selectedCategoryId', cat.id);
    //     store.state.shouldJump = true;
    //     this.$router.push({name: 'GetraenkeProdukte', params: {catname: cat.categoryDE}});
    // },

    clickPlus() {
      this.multiplicator += 1;
      this.updateTotal();
    },
    clickMinus() {
      if (this.multiplicator > 1) {
        this.multiplicator -= 1;
      }
      this.updateTotal();
    },

    findCartItem() {
      try {
        if (this.hasCartItemQuery()) {
          return util.cloneMe(store.getters.cartItems.find(
            cItem => cItem.cartItemId === this.$route.query.cartItemId));
        }
      } catch (e) {

      }
      return null;
    },

    hasCartItemQuery() {
      try {
        return this.$route.query.cartItemId.length > 0;
      } catch (e) {
        return false;
      }
    },

    isDynamic(variant) {
      return variant.trigger && variant.trigger.length > 0;
    },

    updateDynamicVariants() {
      //show or hide dynamicVariants
      let selectedOptionIds = [];
      for (let vStep of this.item.extras.variants) {
        if (vStep.options) {
          for (let opt of vStep.options) {
            if (opt.aaaSelected) {
              selectedOptionIds.push(opt.id);
            }
          }
        }
      }
      // console.log('options selectedOptionIds =  '+selectedOptionIds.length);
      for (let vStep of this.item.extras.variants) {
        if (this.isDynamic(vStep)) {
          let isSelected = false;
          for (let oId of selectedOptionIds) {
            if (vStep.trigger.includes(oId)) {
              isSelected = true;
            }
          }

          vStep.show = isSelected;
          if (!isSelected) {
            for (let opt of vStep.options) {
              opt.aaaSelected = false;
              // console.log('options disabled option for step '+vStep.title);
            }
          } else {
            if (vStep.implicit && vStep.options.length > 0) {
              vStep.options[0].aaaSelected = true;
            }
          }
        }
      }
    },

    selectOhne(variant) {
      console.log('??? selectOhne');
      for (let opt of variant.options) {
        opt.aaaSelected = false;
      }
      variant.aaaOhne = true;
      this.updateDynamicVariants();
      this.updateTotal();
      // this.scrollToNextPlace(variant);
    },

    //gets called 1.
    selectDropdOption(o) {
      this.currentOption = o;
    },

    //gets called 2.
    changeVariant(v, index) {
      if (this.currentOption) {
        this.selectOption(v, this.currentOption, index);
      }
    },

    selectOption(variant, option, index) {
      console.log('??? selectOption');
      variant.aaaOhne = false;
      if (variant.multi) {
        //check for maxOptions
        if (!option.aaaSelected && variant.maxOptions) {
          let countSelected = variant.options.filter(opt => {
            return !!opt.aaaSelected;
          }).length;
          if (countSelected < variant.maxOptions) {
            option.aaaSelected = !option.aaaSelected;
          } else {
            ebus.$emit('info', 'Maximal ' + variant.maxOptions + ' Optionen möglich');
          }
        } else {
          option.aaaSelected = !option.aaaSelected;
        }
      } else {
        if (option.aaaSelected && variant.options.length > 1) {
          option.aaaSelected = false;
        } else {
          for (let opt of variant.options) {
            opt.aaaSelected = false;
          }
          option.aaaSelected = true;
          this.selectModels['sm' + index] = {id: option.id};
        }
      }

      this.updateDynamicVariants();
      this.updateTotal();
      // this.scrollToNextPlace(variant);
    },

    // scrollToNextPlace(variant) {
    //     let nextIdx = this.getNextStepIndex(variant.aaaIndex);
    //     console.log('??? /// nextIdx = ' + nextIdx);
    //     if (nextIdx === -1) {
    //         if (this.item.extras.styles && this.item.extras.styles.length > 0) {
    //             util.delayScroll('extras');
    //         } else {
    //             util.delayScroll('bottomAdd');
    //         }
    //     } else {
    //         util.delayScroll(nextIdx);
    //     }
    // },

    getNextStepIndex(currentStepIdx) {
      let argSuffix = currentStepIdx.substring(5, 7); // begins with "step-XX"
      let argNum = parseInt(argSuffix, 10);
      for (let step of this.item.extras.variants) {
        if (step.show) {
          let paramSuffix = step.aaaIndex.substring(5, 7); // begins with "step-XX"
          let paramNum = parseInt(paramSuffix, 10);
          if (paramNum > argNum) {
            return 'step-' + paramNum;
          }
        }
      }
      return -1;
    },


    findFavItem() {
      try {
        return store.getters.favDrinks.find(f => f.id === this.item.id);
      } catch (e) {

      }
      return null;
    },

    updateFavoriteIcon(preselect) {
      // let restId = store.getters.restId;
      try {
        if (this.item && this.item.id) {
          let isFav = false;
          for (let fav of store.getters.favDrinks) {
            if (fav.id === this.item.id) {
              isFav = true;
              break;
            }
          }
          // if (store.getters.favDrinks.length === 0) {
          let lsFavDrinks = this.$ls.get('favDrinks');
          if (lsFavDrinks) {
            let favDrinks = lsFavDrinks;
            for (let fav of favDrinks) {
              if (fav.id === this.item.id) {
                isFav = true;
                break;
              }
            }
          }
          //     }
          this.isFavorite = isFav;
        } else {
          this.isFavorite = false;
        }

        // //preselect extras from cartItem or from favs
        // let variantsSelected = [];
        // let stylesSelected = [];
        // let cartItem = this.findCartItem();
        // if (cartItem) {
        //     variantsSelected = cartItem.variantsSelected;
        //     stylesSelected = cartItem.stylesSelected;
        // } else if ('extras' in this.item && this.isFavorite) {
        //     let favItem = this.findFavItem();
        //     if (!favItem) {
        //         return;
        //     }
        //     for (let styleSelected of favItem.stylesSelected) {
        //         stylesSelected.push(styleSelected);
        //     }
        //     for (let variantSelected of favItem.variantsSelected) {
        //         variantsSelected.push(variantSelected);
        //     }
        // }
        // if (preselect) {
        //     this.preselectExtras(variantsSelected, stylesSelected);
        // }
      } catch (e) {
        console.log('error in updateFavoriteIcon: ' + e.message);
      }
    },

    preselectSingleVariant() {
      let extras = this.item.extras;
      if (!extras) {
        return;
      }
      if ('variants' in extras) {
        // && d.extras.variants.options
        for (let variant of extras.variants) {
          if (variant.options && !variant.multi) {
            //preselect variant if there is only one
            if (variant.replaceArticle) {
              if (variant.options.length === 1 || variant.implicit) {
                variant.options[0].aaaSelected = true;
                this.updateDynamicVariants();
              }
            } else {
              if (!variant.trigger && (variant.implicit || (variant.options.length === 1 && !variant.optional))) {
                variant.options[0].aaaSelected = true;
                this.updateDynamicVariants();
              }
            }
          }

        }
      }
    },

    preselectExtras(variantsSelected, stylesSelected) {
      let extras = this.item.extras;
      if (!extras) {
        return;
      }
      if ('styles' in extras) {
        for (let style of extras.styles) {
          let found = false;
          for (let styleSelected of stylesSelected) {
            if (styleSelected.id === style.id) {
              found = true;
              style.aaaSelected = true;
            }
          }
          if (!found) {
            style.aaaSelected = false;
          }
        }
      }

      if ('variants' in extras) {
        // && d.extras.variants.options
        let index = 0;
        for (let variant of extras.variants) {
          if (variant.options) {
            for (let option of variant.options) {
              let found = false;
              for (let variantSelected of variantsSelected) {
                if (variantSelected.id === option.id) {
                  found = true;
                  option.aaaSelected = true;
                  this.selectModels['sm' + index] = {id: option.id};
                }
              }
              if (!found) {
                option.aaaSelected = false;
              }
            }
          }
          ++index;
        }
      }

    },
    tryIncrement(item) {
      // if (item.sizes && item.sizes.length === 1) {
      if (!item.sizes || item.sizes.length === 0) {
        return;
      }
      if (this.currentVol.length > 0) {
        let size = this.findSizeByVol(this.item.sizes, this.currentVol);
        if (size) {
          this.inc(size);
          return;
        }
      }
      let size = item.sizes[0];
      this.inc(size);
      // }
    },

    inc(size) {
      // try {
      //     size.aaaCount++;
      // } catch (e) {
      //     alert('size aaaCount missing');
      // }
      size.aaaCount++; //at the moment we increment to only 1
      this.currentVol = size.vol;
      this.updateTotal();
      // util.delayScroll('sizes');
    },

    dec(size) {
      if (size.aaaCount > 0) {
        size.aaaCount--;
        this.updateTotal();
      }
    },

    switchFavorite() {
      console.log('switchFavorite is Favorite = ' +
        this.isFavorite);

      let _itemId = '' + this.item.id;
      if (this.isFavorite) {
        store.commit('removeFavDrink', _itemId);
        this.isFavorite = false;
      } else {
        let itemClone = util.cloneMe(this.item);
        let fav = {
          id: _itemId,
          num: itemClone.num,
          posId: itemClone.posId,
          image: itemClone.image,
          nameToDisplay: itemClone.nameDE,
          extras: [],
          extrasToDisplay: [], //['eins', 'zwe' ] //or empty array
          variantsSelected: [], //[{...},{...}]
          stylesSelected: [], //[{...},{...}]
          vol: '' + this.currentVol
        };
        // let size = itemClone.sizes[0];
        // if (this.currentVol.length > 0) {
        //     let relevantSize = this.findSizeByVol(itemClone.sizes, fav.vol);
        //     if (relevantSize) {
        //         size = relevantSize;
        //     }
        // }
        // if (!this.fillItemWithSelectedExtras(size, fav, itemClone)) {
        //     //do not add fav drink if there the user needs to select options first
        //     return;
        // }
        store.commit('addFavDrink', fav);
        this.isFavorite = true;
        // ebus.$emit('toast', ' wurde als Favorit gespeichert!');
        // ebus.$emit('toast', {
        //     msg: this.item.nameDE + ' wurde als Favorit gespeichert!',
        //     time: 2500
        // });
      }

      // ebus.$emit('favoritesUpdated');
      ebus.$emit('saveUserPreferences');
      setTimeout(() => {
        ebus.$emit('combineFavs');
        // ebus.$emit('favoritesUpdated');
      }, 100);//give saveUserSettings in App.vue time to update the localStorage
    },

    readyToAdd(item) {
      if (item.extras && item.extras.variants) {
        for (let i = 0; i < item.extras.variants.length; i++) {
          let v = item.extras.variants[i];
          if (v.options) {
            if (util.getSelectedOptions(v) === '-1') {
              return false;
            }
          }
        }
      }
      return true;
      // return util.getSelectedOptions(itemClone.extras.variants.variant) !== '-1';
    },

    fillItemWithSelectedExtras(size, item, itemClone) {
      //variants => fill extrasToDisplay and variantsSelected
      if (itemClone.extras) {

        if (itemClone.extras.variants) {
          for (let v = 0; v < itemClone.extras.variants.length; v++) {
            var _variant = itemClone.extras.variants[v];
            if (_variant.options) {

              let freeArticles = _variant.freeArticles ? _variant.freeArticles : 0;
              let selectedArticles = 0;

              let selectedOptions = util.getSelectedOptions(_variant);

              if (selectedOptions === '-1') {
                // this.$notify({
                //     title: 'Bitte wähle eine Option aus für "' + _variant.title + '"',
                //     text: ' ',
                //     type: 'error'
                // });
                if (!this.addDirectly) {
                  store.commit('currentNext', '');
                  let vt = _variant.title?.length ? _variant.title : 'Welche Größe?'
                  ebus.$emit('showInfo', {
                    title: 'Du musst noch eine Auswahl treffen für "' + vt + '"',
                    // text: 'Bitte wähle eine Option aus für "' + _variant.title + '"',
                  });
                  console.log('DEBUG ITEM name: ' + item.nameDE);
                }

                return false;
              }

              if (selectedOptions !== 'ohne' && selectedOptions !== 'aaaOhne') {
                // item.variantsToDisplay.push(selectedOption.labelDE);
                for (let so of selectedOptions) {
                  ++selectedArticles;
                  item.extrasToDisplay.push(so.labelDE);
                  let extra = {
                    name: so.labelDE,
                    price: so.cost,
                    posId: so.posId,
                  };
                  if (itemClone.extras.combinations) {
                    extra.price = itemClone.extras.combinations.find(c => c.id === so.id).price
                  }
                  if (selectedArticles <= freeArticles) {
                    extra.price = 0;
                  }
                  item.extras.push(extra);
                  // item.extrasEN.push(_variant.selectedOption.labelEN);
                  item.variantsSelected.push(so);
                }

              }
            }
          }
        }

        //styles => fill extrasToDisplay and stylesSelected
        if (itemClone.extras.styles) {
          for (var s = 0; s < itemClone.extras.styles.length; s++) {
            var _style = itemClone.extras.styles[s];
            if (_style.aaaSelected) {
              item.extrasToDisplay.push(_style.labelDE);
              // item.extrasEN.push(_style.labelEN);
              let extraPrice = util.getExtraPrice(_style, size.vol);
              let extra = {
                name: _style.labelDE,
                price: extraPrice,
                posId: _style.posId,
              };
              item.extras.push(extra);
              item.stylesSelected.push(_style);

            }
          }
        }
      }
      return true;
    },

    // getExtraPrice(extra, size) {
    //     if ('volCosts' in extra) {
    //         for (let volCost of extra.volCosts) {
    //             if (volCost.volName === size.vol) {
    //                 return volCost.cost;
    //             }
    //         }
    //     }
    //     return extra.cost;
    // },

    findSizeByVol(sizes, vol) {
      for (let s of sizes) {
        if (s.vol === vol) {
          return s;
        }
      }
      return null;
    },

    switchSize(volName) {
      //size contains vol and price
      this.currentVol = volName;

      for (let s of this.item.sizes) {
        if (s.vol === this.currentVol) {
          s.aaaCount = 1;
        } else {
          s.aaaCount = 0;
        }
      }

      this.updateTotal();
      // this.scrollFromSizesToNextPlace();
    },

    switchExtra(extra) {
      extra.aaaSelected = !extra.aaaSelected;
      this.updateTotal();

      if (extra.aaaSelected) {
        //because we have alot of extras per pizza
        let i = 0;
        for (; i < this.item.extras.styles.length; i++) {
          let _extra = this.item.extras.styles[i];
          if (_extra.id === extra.id) {
            break;
          }
        }
        let breaks = 3;
        let bodyEl = document.body;
        //document.getElementsByTagName('BODY')[0];
        if (bodyEl.classList.contains('device-md')) {
          breaks = 4;
        }
        let nextId = (((i + 1) % breaks) === breaks) ? i + breaks : i;
        if (nextId < this.item.extras.styles.length) {
          // util.delayScroll(this.item.extras.styles[nextId].id);
        } else {
          // util.delayScroll('bottomAdd');
        }
      }

      // util.delayScroll('sizes');
    },

    getSumOfExtras() {
      let result = {
        sumOfSteps: 0,
        sumOfExtras: 0,
        hasVolCosts: false
        // '30 cm': 0.7,
        // '40 cm': 1.57
      };

      try {
        if (this.item.extras) {

          //add extra costs
          if (this.item.extras.styles) {
            for (let extra of this.item.extras.styles) {
              if (extra.aaaSelected) {
                if ('volCosts' in extra) {
                  result.hasVolCosts = true;
                  for (let volCost of extra.volCosts) {
                    let cost = extra.cost;
                    if (volCost.cost) {
                      cost = volCost.cost;
                    }
                    if (!result[volCost.volName]) {
                      result[volCost.volName] = 0;
                    }
                    result[volCost.volName] += cost;
                  }
                  // } else {
                  //     result.sumOfExtras += extra.cost;
                  // }
                }
                //sumOfExtras = required for single size items
                // and as a fallback if extras are multiSize but not the item itself
                result.sumOfExtras += extra.cost;
              }
            }
          }

          //add variants cost
          if (this.item.extras.variants) {
            for (let variant of this.item.extras.variants) {
              let freeArticles = variant.freeArticles ? variant.freeArticles : 0;
              //ignore replaceArticle steps while calculating extras
              if (!variant.replaceArticle && variant.options) {
                let selectedArticles = 0;
                for (let option of variant.options) {
                  if (option.aaaSelected) {
                    ++selectedArticles;
                    if (selectedArticles > freeArticles) {
                      result.sumOfSteps += option.cost;
                    }
                  }
                }
              }
            }
          }

        }
      } catch (e) {
        // alert('Error in getSumOfExtras: ' + JSON.stringify(e))
      }

      return result;
    },
    getSizePrices(size, isMultiSize) {
      let sizePrices = {
        sizeTotal: size.price * size.aaaCount,
        sumOfExtras: 0
      };

      if (size.takeAwayPrice) {
        sizePrices.sizeTakeAwayTotal = (size.takeAwayPrice * size.aaaCount);
      }
      if (size.deliveryPrice) {
        sizePrices.sizeDeliveryTotal = (size.deliveryPrice * size.aaaCount);
      }

      // console.log('sizePrices.sizeTakeAwayTotal = '+sizePrices.sizeTakeAwayTotal);
      // console.log('sizePrices.sizeTotal = '+sizePrices.sizeTotal);

      let sumOfExtras = this.getSumOfExtras();

      console.log('??? sumOfExtras = ' + JSON.stringify(sumOfExtras));

      if (isMultiSize && sumOfExtras.hasVolCosts) {
        //Multiply by size selections
        sizePrices.sumOfExtras = (sumOfExtras.sumOfSteps + sumOfExtras[size.vol]) * size.aaaCount;
      } else {
        //Multiply by size selections
        sizePrices.sumOfExtras = (sumOfExtras.sumOfSteps + sumOfExtras.sumOfExtras) * size.aaaCount;
      }

      return sizePrices;
    },
    addToCart() {

      // //Filial check for orderingEnabled
      // if(!this.orderingEnabled){
      //     setTimeout(() => {
      //         ebus.$emit('showInfo', {
      //             title: qconst.string$filiale_preorder_note,
      //             text: '',
      //         });
      //     }, 1000);
      //     this.$store.commit('showDialogContainer', true);
      //     this.$store.commit('selectedDialog', 'SelectFiliale');
      // //     this.$router.push({name: 'Filialen'});
      //     return;
      // }

      // ebus.$emit('showInfo', {
      //     title: 'Zum Bestellen rufe bitte den Kellner',
      //     // text: 'Durch Angabe deiner Mobilnummer können wir ' +
      //     //     +'Kontakt zu dir aufnehmen, falls es Rückfragen zu deiner Bestellung geben sollte'
      // });
      //only for iframes
      // document.querySelectorAll('.v-dialog').forEach((d) => {
      //     d.style.top = store.state.yA + 'px';
      // });

      this.itemToAdd = cloneMe(this.item);
      if (!this.itemToAdd.onlineGutschein
        && !this.itemToAdd.ticket
      ) {
        if (store.state.enableOrderModeSelection && !store.getters.selectedOrderModeByUser) {
          ebus.$emit('showOrderModeSwitchDialog', true);
          return;
        }
      }

      //Clone the item first
      if (this.multiplicator < 1) {
        this.multiplicator = 1;
      }

      //Check if unikat is already in cart
      if (this.item.unikat) {
        for (let itm of store.getters.cartItems) {
          if (itm.id === this.item.id) {
            return;
          }
        }
      }

      // if (store.getters.inhouse && qconst.enableGangSelection) {
      //     if (qconst.categoriesToExcludeFromGangSelection.includes(this.selectedCat.categoryDE)) {
      let n = Date.now();
      this.doAddToCart();
      //     } else {
      //         ebus.$emit('showQuestion', {
      //             quest: 'Soll diese Speise als Vorspeise oder als Hauptseise serviert werden?',
      //             // text: '',
      //             yesLabel: 'Vorspeise',
      //             noLabel: 'Hauptspeise',
      //             // yesAction: null,
      //             cb: 'cb-startersHint'
      //         });
      //     }
      // } else {
      //     this.doAddToCart();
      // }
    },

    doAddToCart(config) {
      console.log('doAddToCart config: ', config);
      let selectedVol = '';
      for (let i = 0; i < this.multiplicator; i++) {
        let itemClone = util.cloneMe(this.item);

        console.log('doAddToCart item: ', itemClone);

        let anySize = false;

        //Add one item for every size
        if (itemClone.sizes) {

          // let sumOfExtrasMap = this.getSumOfExtras();

          for (let size of itemClone.sizes) {

            //cuurrently aaaCount=1 means the size is selected and aaaCount=0 the size is NOT selected
            if (size.aaaCount < 1) {
              continue;
            }

            // size.aaaCount = size.aaaCount * this.multiplicator;

            anySize = true;

            // if(itemClone.sizes.length === 2 && )


            let sizePrices = 0;
            let sizePrice = 0; //without extras
            let rStep = itemUtil.findReplaceArticleStep(this.item);
            if (rStep) {
              sizePrices = {
                sizeTotal: 1 + this.replacePrice - 1,
                sumOfExtras: this.getSumOfExtras().sumOfExtras + this.getSumOfExtras().sumOfSteps
              };
              sizePrice = sizePrices.sizeTotal;
            } else if (this.item.extras && this.item.extras.combinations) {
              sizePrices = {
                sizeTotal: 1 + this.combiPrice - 1,
                sumOfExtras: this.getSumOfExtras().sumOfExtras + this.getSumOfExtras().sumOfSteps
              };
              sizePrice = sizePrices.sizeTotal;
            } else {
              sizePrice = size.price;
              sizePrices = this.getSizePrices(size, itemClone.sizes.length > 1);
            }


            // console.log('??? sizePrices: ' + JSON.stringify(sizePrices));//{"sizeTotal":21,"sumOfExtras":0}
            selectedVol = size.vol;


            let item = {
              sourceItem: itemClone,
              categoryDE: itemClone.categoryDE,
              id: itemClone.id,
              articleNo: '',
              posId: itemClone.posId,
              delay: this.selectedCat.delay,
              cartItemId: util.generateClientId(),
              isOffer: !!(size.offerId), //offers and cartItems ar always size specific
              type: qconst.type$drinkOrder,
              nameToDisplay: itemClone.nameDE,
              description: '' + itemClone.descriptionDE,
              // days: itemClone.days,
              notes: '',
              gramm: itemClone.gramm,
              unikat: !!(itemClone.unikat),
              // lieferzeit: '' + itemClone.lieferzeit,
              // kilopreis: '' + itemClone.kilopreis,
              // streichPreis: itemClone.streichPreis,
              // sumOfExtras: sumOfExtras,
              sizePrice: sizePrice,
              // takeAwaySizePrice: size.price,
              // deliverySizePrice: size.price,
              // nameEN: thisDrink.nameEN,
              sumOfExtras: sizePrices.sumOfExtras,// this.total - (size.price * size.aaaCount),
              itemTotal: sizePrices.sizeTotal + sizePrices.sumOfExtras,
              // takeAwayItemTotal: sizePrices.sizeTotal + sizePrices.sumOfExtras,
              // deliveryItemTotal: sizePrices.sizeTotal + sizePrices.sumOfExtras,
              count: size.aaaCount,
              vol: size.vol,
              extras: [
                // {name:'',price:0}
              ],
              // variantsToDisplay: [],
              extrasToDisplay: [], //['eins', 'zwe' ] //or empty array
              // extrasEN: [], //['value one', 'value two' ] //or empty array
              variantsSelected: [], //['234234asdasd', '567567gfddfg'] //unsique ids within the complete menu
              stylesSelected: [] //['234234asdasd', '567567gfddfg'] //unsique ids within the complete menu
            };

            if (itemClone.notes) {
              item.notes = itemClone.notes;
            }
            if (!store.state.enableBestand) {
              item.hasBestand = false;
              item.bestand = -1;
            } else if (itemClone.bestand !== -1) {
              item.hasBestand = true;
              item.bestand = itemClone.bestand;
            }
            if (itemClone.ticket) {
              item.ticket = itemClone.ticket;
              item.type = qconst.type$generic;
            }
            if (itemClone.articleNo) {
              item.articleNo = itemClone.articleNo;
            }
            if (itemClone.days) {
              item.days = itemClone.days;
            }
            if (itemClone.onlineGutschein) {
              item.onlineGutschein = true;
            }
            if (itemClone.offlineGutschein) {
              item.offlineGutschein = true;
            }

            if (config && config.additionalProps) {
              Object.keys(config.additionalProps).forEach((key) => {
                item[key] = config.additionalProps[key];
              });
            }

            // if (size.takeAwayPrice) {
            //     item.takeAwaySizePrice = size.takeAwayPrice;
            // }
            // if (size.deliveryPrice) {
            //     item.deliverySizePrice = size.deliveryPrice;
            // }

            // if (sizePrices.sizeTakeAwayTotal) {
            //     item.takeAwayItemTotal = sizePrices.sizeTakeAwayTotal + sizePrices.sumOfExtras;
            // }
            // if (sizePrices.sizeDeliveryTotal) {
            //     item.deliveryItemTotal = sizePrices.sizeDeliveryTotal + sizePrices.sumOfExtras;
            // }

            item.articleNo = util.getArtikelnummerOfItem(itemClone);

            if (rStep) {
              for (let o of rStep.options) {
                if (o.aaaSelected) {
                  item.posId = o.posId;
                  break;
                }
              }

              //append the posId of the main article because Lightspeed required the main article
              item.mainPosId = item.posId;
            }

            if (size.offerId) {
              item.offerId = size.offerId;
              item.offerName = '';
              item.offerUsecase = '';

              let offer = store.getters.getOfferById(size.offerId);
              if (offer) {
                item.offerName = offer.name;
                item.offerUsecase = offer.usecase;
              }
            }

            if (!this.addDirectly && !this.fillItemWithSelectedExtras(size, item, itemClone)) {
              return;
            }

            setGlobalKeyValue('userWantsToAddItemToCart', {item: cloneMe(item), count: 0 + this.multiplicator});
            store.commit('addItemToCart', {item: item});
            if (this.$store.getters.showDialogContainer) {
              this.$store.commit('showDialogContainer', false);
            }

          }//eof size loop
        }

        //add the items as currently represented by this page to the store


        if (anySize) {
          // gevent('add_to_cart', {
          //     currency: 'EUR',
          //     value: this.fulltotal,
          //     items: [this.getAnalyticsItem(this.multiplicator, selectedVol)]
          // });

          //Finally reset the input

          // for (let s of this.item.sizes) {
          //     s.aaaCount = 0;
          // }
          // this.currentVol = '';

          // this.init();

          //Trigger animation
          //https://css-tricks.com/restart-css-animation/
          // cartanimation.trigger();
          // store.commit('showAddedOverlay', true);
          this.noblink = true;
          // ebus.$emit('itemAdded');
          setTimeout(() => {
            // store.commit('showAddedOverlay', false);
            this.showWeiter = true;
          }, 900);
          if (this.addDirectly) {
            this.itemAddedEvent();
          }
          // cartanimation.flyToCart();
        }
      }
    },

    updateTotal() {
      let sum = 0;
      console.log('!!! updateTotal');
      let rStep = itemUtil.findReplaceArticleStep(this.item);
      if (rStep) {
        let found = false;
        for (let option of rStep.options) {
          if (option.aaaSelected) {
            sum = option.cost;
            found = true;
          }
        }
        if (!found) {
          //use price of first option
          sum = rStep.options[0].cost;
        }
        this.replacePrice = 1 + sum - 1;

        let sumOfExtras = this.getSumOfExtras();
        sum += sumOfExtras.sumOfSteps + sumOfExtras.sumOfExtras; //not does not work with multipleSizes

      } else if (this.item.extras && this.item.extras.combinations && this.item.extras.variants) {
        let ids = [];
        for (let variant of this.item.extras.variants) {
          if (variant.options) {
            for (let option of variant.options) {
              if (option.aaaSelected) {
                ids.push(option.id);
              }
            }
          }
        }
        let combiId = ids.join('.');

        //now get the price for this combiId
        let combiFound = false;
        for (let combi of this.item.extras.combinations) {
          if (combi.id === combiId) {
            combiFound = true;
            sum = combi.price;
            console.log('combi found with price ' + sum);
          }
        }

        if (!combiFound) {
          //use price of first combi
          sum = this.item.extras.combinations[0].price;
        }

        this.combiPrice = 1 + sum - 1;

        let sumOfExtras = this.getSumOfExtras();
        sum += sumOfExtras.sumOfSteps + sumOfExtras.sumOfExtras; //not does not work with multipleSizes

      } else {

        if (this.item.sizes) {
          let multiSize = this.item.sizes.length > 1;
          for (let size of this.item.sizes) {

            if (size.aaaCount < 1) {
              continue;
            }

            let sizePrices = this.getSizePrices(size, multiSize);
            console.log('??? sizePrices = ' + JSON.stringify(sizePrices));
            if (typeof sizePrices.sumOfExtras !== 'number') {
              // alert('Error in price data');
              continue
            }
            let itemTotal = sizePrices.sizeTotal + sizePrices.sumOfExtras;

            sum += itemTotal;
          }
        }
      }

      // if(itemClone.sizes.length === 2 && )

      this.total = sum;
      this.fulltotal = sum * this.multiplicator;
    }
  },
}
</script>

<style scoped lang="scss">
@import '../styles/base';

.page {
  &.noPadding {
    padding-top: 0;
  }
}

.nflex {
  flex: none;

  &.dc {
    display: contents;
  }
}

.alk {
  margin-left: 5px;
  color: white;

  &.bgLight {
    color: black;
  }
}

.absSelects {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  color: #ffffff;
  opacity: 0.8;
  height: 100%;
  width: 85%;

  &.bgLight {
    color: $font-color;
  }
}

.mobileImg {
  overflow-x: hidden;
  width: 100%;
  display: flex;
}

/*.mobileImg ::v-deep .v-responsive__content {*/
/*    width: var(--layout-width) !important;*/
/*}*/

.preis {
  font-size: 1.25em;
}

.oprice {
  color: $offer-color;
}

.page .v-chip.v-size--default {
  font-size: 17px;
}

h2 {
  word-wrap: break-word;
}

.sliderImg {
  width: 100%;
  height: 100%;
  background-position: center;
  //background-position: 0 100%; //focused corner is bottom left
  background-repeat: no-repeat;
  background-size: contain;
}

.n-marge {
  margin-left: -8px;
}

.page .v-expansion-panel-header {
  font-size: 1em !important;
  /*font-weight: 700 !important;*/
  /*letter-spacing: 0.075em;*/
}

/*.catSlider {*/
/*    position: fixed;*/
/*    top: 67px;*/
/*    left: 0;*/
/*    width: 100%;*/
/*}*/


/*.page .v-btn.v-size--large {*/
/*    font-size: 1.2em;*/
/*    height: 70px;*/
/*    border-right: 1px solid gray;*/
/*}*/

.moreImagesBottom {
  /*position: absolute;*/
  /*top: 15px;*/
  /*right: 15px;*/
  padding-top: 15px;
  min-width: 95px;
  width: 100%;
  text-align: left;
  height: 100%;
  overflow-y: hidden;
  /*height: 81px; // 1 is ofr the border top*/

  .moreImage {
    display: inline-block;
    border-radius: $box-border-radius;
    width: 80px;
    height: 80px;
    margin-bottom: 15px;
    margin-right: 10px;
    /*border-left: 1px solid #737373;*/
    /*border-top: 1px solid #737373;*/

  }
}

/*.absKennz {*/
/*    position: absolute;*/
/*    bottom: 2px;*/
/*    left: 4px;*/
/*    pointer-events: none;*/
/*    height: 70px;*/
/*}*/

.badge {
  height: 62px;

  img {
    display: inline-block;
    width: auto;
    height: 62px;
  }
}

.product-image {
  height: 250px;
  max-height: 250px;
  /*overflow: hidden;*/
  /*background-color: #333;*/
  position: relative;

  &.hasmoreimages {
    padding-left: 98px;
  }

  .moreImagesLeft {
    position: absolute;
    top: 0;
    left: 0;
    width: 80px;
    /*height: 100%;*/
    .moreImage {
      margin-bottom: 8px;
      border-radius: $box-border-radius;
      width: 80px;
      height: 80px;
    }
  }
}

.moreImage {
  /*border: 1px solid white;*/
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

//.mobile {
//  .product-image {
//    overflow: hidden;
//  }
//}

.absKennz {
  left: initial;
  right: 4px;
}

.product-image .mainImage ::v-deep img {
  width: 100%;
  max-height: 400px;
}

.product-image {
  max-height: 400px;
  //max-width: 29vw;

  .mainImage {
    width: 100%;
    max-height: 400px;
    //max-width: 29vw;
    border-radius: $box-border-radius;
  }

  /*<!--//@include material-shadow(1);-->*/
  /*<!--border-radius: $box-border-radius;-->*/
  /*<!--background-position: center;-->*/
  /*<!--background-repeat: no-repeat;-->*/
  /*<!--background-size: contain;-->*/
}

.tablet {
  .limited {
    width: 90%;
    max-width: 380px;
  }

  .product-image {
    max-width: 29vw;

    .mainImage {
      max-width: 29vw;
    }
  }

  .product-image .mainImage ::v-deep img {
    max-width: 29vw;
  }
}

/*.device-md {*/
/*    .absBack {*/
/*        position: sticky*/
/*    }*/
/*}*/

/*.device-xs {*/
/*    .lightbox .inner .close {*/
/*        position: fixed;*/
/*        top: 100px;*/
/*        right: 0;*/
/*    }*/
/*}*/

.heart {
  /*position: absolute;*/
  /*top: 10px;*/
  /*right: 10px;*/
  width: 35px;
  height: 35px;
  /*text-align: right;*/
}

/*.heart ::v-deep .v-btn {*/
/*    background-color: rgba(black, 0.3);*/
/*}*/

/*.heart ::v-deep i {*/
/*    font-size: 36px !important;*/
/*}*/

.limited {
  width: 100%;
  //max-width: 380px;
}

.moreTitle {
  margin-top: 40px;
  margin-bottom: 20px;
}


///////////////
.counterStuff {
  cursor: pointer;
  width: 40px;
  text-align: center;

  padding: 0;

  img {
    width: 32px;
    height: auto;
    margin: 0 7px;
    margin-top: 5px;
  }

  &.minus {
    img {
      margin-left: 0;
    }
  }

  /*>>> .v-btn{*/
  /*    width: 32px;*/
  /*    height: 32px;*/
  /*    margin: 0;*/
  /*}*/
}

td.counter {
  //color: $font-color;
  width: 27px;
  font-size: 1.2em;
  text-align: center;
}


//////////////////////
.lightbox {
  padding-top: $headHeight;
  pointer-events: all;
  transition: all 0.4s ease;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 55;
  width: 100%;
  height: 100%;
  background-color: rgba(black, 0.7);

  .inner {
    display: inline-block;
    width: 90%;
    max-width: 1200px;
    position: relative;

    .close {
      z-index: 5;
      position: absolute;
      top: -10px;
      right: -10px;
      padding: 15px;
    }
  }
}

.vdevice-xs {
  .lightbox {
    .inner {
      width: 100%;
    }
  }
}

.device-xs {
  .lightbox ::v-deep .close {
    position: fixed;
    top: 75px;
    right: 10px;
  }
}


</style>
